// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v7.35.1
// source: trading-bridge.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";
import { Security } from "./candle-data-depot-common";
import { Empty } from "./google/protobuf/empty";
import {
  Broker_OrderType,
  broker_OrderTypeFromJSON,
  broker_OrderTypeToJSON,
  Broker_Variety,
  broker_VarietyFromJSON,
  broker_VarietyToJSON,
  MarginFromBrokerRequest,
  MarginFromBrokerResponse,
  Order,
  Orders,
  Product,
  productFromJSON,
  productToJSON,
  Trade,
  TransactionType,
  transactionTypeFromJSON,
  transactionTypeToJSON,
  Validity,
  validityFromJSON,
  validityToJSON,
} from "./order";
import { Position as Position1 } from "./position";
import Long from "long";

export const protobufPackage = "com.tick2trade.api.tradingbridge";

export enum TradingAccountStatus {
  STATUS_UNKNOWN = 0,
  ACTIVE = 1,
  BROKEN = 2,
  /** @deprecated */
  SYNC_PENDING = 3,
  /** @deprecated */
  SYNC_IN_PROGRESS = 5,
  /** @deprecated */
  SYNC_FAILED = 6,
  /** KYC_INITIATED - KYC / demat onboarding lifecycle: */
  KYC_INITIATED = 7,
  /** DOCUMENTS_SUBMITTED - user completed Digio flow (webhook: submitted) */
  DOCUMENTS_SUBMITTED = 8,
  /** DOCUMENTS_VERIFIED - Digio/compliance approved KYC — awaiting admin activation */
  DOCUMENTS_VERIFIED = 9,
  /** KYC_REJECTED - compliance rejected */
  KYC_REJECTED = 10,
  /** DELETED - soft-deleted (e.g. practice account reset) */
  DELETED = 11,
  /** DISABLED - practice account disabled by user */
  DISABLED = 12,
  UNRECOGNIZED = -1,
}

export function tradingAccountStatusFromJSON(object: any): TradingAccountStatus {
  switch (object) {
    case 0:
    case "STATUS_UNKNOWN":
      return TradingAccountStatus.STATUS_UNKNOWN;
    case 1:
    case "ACTIVE":
      return TradingAccountStatus.ACTIVE;
    case 2:
    case "BROKEN":
      return TradingAccountStatus.BROKEN;
    case 3:
    case "SYNC_PENDING":
      return TradingAccountStatus.SYNC_PENDING;
    case 5:
    case "SYNC_IN_PROGRESS":
      return TradingAccountStatus.SYNC_IN_PROGRESS;
    case 6:
    case "SYNC_FAILED":
      return TradingAccountStatus.SYNC_FAILED;
    case 7:
    case "KYC_INITIATED":
      return TradingAccountStatus.KYC_INITIATED;
    case 8:
    case "DOCUMENTS_SUBMITTED":
      return TradingAccountStatus.DOCUMENTS_SUBMITTED;
    case 9:
    case "DOCUMENTS_VERIFIED":
      return TradingAccountStatus.DOCUMENTS_VERIFIED;
    case 10:
    case "KYC_REJECTED":
      return TradingAccountStatus.KYC_REJECTED;
    case 11:
    case "DELETED":
      return TradingAccountStatus.DELETED;
    case 12:
    case "DISABLED":
      return TradingAccountStatus.DISABLED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TradingAccountStatus.UNRECOGNIZED;
  }
}

export function tradingAccountStatusToJSON(object: TradingAccountStatus): string {
  switch (object) {
    case TradingAccountStatus.STATUS_UNKNOWN:
      return "STATUS_UNKNOWN";
    case TradingAccountStatus.ACTIVE:
      return "ACTIVE";
    case TradingAccountStatus.BROKEN:
      return "BROKEN";
    case TradingAccountStatus.SYNC_PENDING:
      return "SYNC_PENDING";
    case TradingAccountStatus.SYNC_IN_PROGRESS:
      return "SYNC_IN_PROGRESS";
    case TradingAccountStatus.SYNC_FAILED:
      return "SYNC_FAILED";
    case TradingAccountStatus.KYC_INITIATED:
      return "KYC_INITIATED";
    case TradingAccountStatus.DOCUMENTS_SUBMITTED:
      return "DOCUMENTS_SUBMITTED";
    case TradingAccountStatus.DOCUMENTS_VERIFIED:
      return "DOCUMENTS_VERIFIED";
    case TradingAccountStatus.KYC_REJECTED:
      return "KYC_REJECTED";
    case TradingAccountStatus.DELETED:
      return "DELETED";
    case TradingAccountStatus.DISABLED:
      return "DISABLED";
    case TradingAccountStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum SegmentActivationStatus {
  SEGMENT_ACTIVATION_STATUS_UNKNOWN = 0,
  SEGMENT_ACTIVATION_PENDING = 1,
  SEGMENT_ACTIVATION_ACTIVE = 2,
  SEGMENT_ACTIVATION_DEACTIVATED = 3,
  UNRECOGNIZED = -1,
}

export function segmentActivationStatusFromJSON(object: any): SegmentActivationStatus {
  switch (object) {
    case 0:
    case "SEGMENT_ACTIVATION_STATUS_UNKNOWN":
      return SegmentActivationStatus.SEGMENT_ACTIVATION_STATUS_UNKNOWN;
    case 1:
    case "SEGMENT_ACTIVATION_PENDING":
      return SegmentActivationStatus.SEGMENT_ACTIVATION_PENDING;
    case 2:
    case "SEGMENT_ACTIVATION_ACTIVE":
      return SegmentActivationStatus.SEGMENT_ACTIVATION_ACTIVE;
    case 3:
    case "SEGMENT_ACTIVATION_DEACTIVATED":
      return SegmentActivationStatus.SEGMENT_ACTIVATION_DEACTIVATED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SegmentActivationStatus.UNRECOGNIZED;
  }
}

export function segmentActivationStatusToJSON(object: SegmentActivationStatus): string {
  switch (object) {
    case SegmentActivationStatus.SEGMENT_ACTIVATION_STATUS_UNKNOWN:
      return "SEGMENT_ACTIVATION_STATUS_UNKNOWN";
    case SegmentActivationStatus.SEGMENT_ACTIVATION_PENDING:
      return "SEGMENT_ACTIVATION_PENDING";
    case SegmentActivationStatus.SEGMENT_ACTIVATION_ACTIVE:
      return "SEGMENT_ACTIVATION_ACTIVE";
    case SegmentActivationStatus.SEGMENT_ACTIVATION_DEACTIVATED:
      return "SEGMENT_ACTIVATION_DEACTIVATED";
    case SegmentActivationStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum KillSwitchDuration {
  KILL_SWITCH_DURATION_UNKNOWN = 0,
  THIRTY_MINUTES = 1,
  ONE_HOUR = 2,
  UNTIL_DAY_END = 3,
  UNRECOGNIZED = -1,
}

export function killSwitchDurationFromJSON(object: any): KillSwitchDuration {
  switch (object) {
    case 0:
    case "KILL_SWITCH_DURATION_UNKNOWN":
      return KillSwitchDuration.KILL_SWITCH_DURATION_UNKNOWN;
    case 1:
    case "THIRTY_MINUTES":
      return KillSwitchDuration.THIRTY_MINUTES;
    case 2:
    case "ONE_HOUR":
      return KillSwitchDuration.ONE_HOUR;
    case 3:
    case "UNTIL_DAY_END":
      return KillSwitchDuration.UNTIL_DAY_END;
    case -1:
    case "UNRECOGNIZED":
    default:
      return KillSwitchDuration.UNRECOGNIZED;
  }
}

export function killSwitchDurationToJSON(object: KillSwitchDuration): string {
  switch (object) {
    case KillSwitchDuration.KILL_SWITCH_DURATION_UNKNOWN:
      return "KILL_SWITCH_DURATION_UNKNOWN";
    case KillSwitchDuration.THIRTY_MINUTES:
      return "THIRTY_MINUTES";
    case KillSwitchDuration.ONE_HOUR:
      return "ONE_HOUR";
    case KillSwitchDuration.UNTIL_DAY_END:
      return "UNTIL_DAY_END";
    case KillSwitchDuration.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum NomineeChangeRequestStatus {
  NOMINEE_CHANGE_REQUEST_STATUS_UNKNOWN = 0,
  NOMINEE_CHANGE_REQUEST_PENDING = 1,
  NOMINEE_CHANGE_REQUEST_APPROVED = 2,
  NOMINEE_CHANGE_REQUEST_REJECTED = 3,
  UNRECOGNIZED = -1,
}

export function nomineeChangeRequestStatusFromJSON(object: any): NomineeChangeRequestStatus {
  switch (object) {
    case 0:
    case "NOMINEE_CHANGE_REQUEST_STATUS_UNKNOWN":
      return NomineeChangeRequestStatus.NOMINEE_CHANGE_REQUEST_STATUS_UNKNOWN;
    case 1:
    case "NOMINEE_CHANGE_REQUEST_PENDING":
      return NomineeChangeRequestStatus.NOMINEE_CHANGE_REQUEST_PENDING;
    case 2:
    case "NOMINEE_CHANGE_REQUEST_APPROVED":
      return NomineeChangeRequestStatus.NOMINEE_CHANGE_REQUEST_APPROVED;
    case 3:
    case "NOMINEE_CHANGE_REQUEST_REJECTED":
      return NomineeChangeRequestStatus.NOMINEE_CHANGE_REQUEST_REJECTED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return NomineeChangeRequestStatus.UNRECOGNIZED;
  }
}

export function nomineeChangeRequestStatusToJSON(object: NomineeChangeRequestStatus): string {
  switch (object) {
    case NomineeChangeRequestStatus.NOMINEE_CHANGE_REQUEST_STATUS_UNKNOWN:
      return "NOMINEE_CHANGE_REQUEST_STATUS_UNKNOWN";
    case NomineeChangeRequestStatus.NOMINEE_CHANGE_REQUEST_PENDING:
      return "NOMINEE_CHANGE_REQUEST_PENDING";
    case NomineeChangeRequestStatus.NOMINEE_CHANGE_REQUEST_APPROVED:
      return "NOMINEE_CHANGE_REQUEST_APPROVED";
    case NomineeChangeRequestStatus.NOMINEE_CHANGE_REQUEST_REJECTED:
      return "NOMINEE_CHANGE_REQUEST_REJECTED";
    case NomineeChangeRequestStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Generic change-request types stored in trading_account_change_request.request_type */
export enum TradingAccountChangeRequestType {
  TRADING_ACCOUNT_CHANGE_REQUEST_TYPE_UNKNOWN = 0,
  UPSERT_NOMINEES = 1,
  ADD_BANK_ACCOUNT = 2,
  ACTIVATE_SEGMENT = 3,
  UNRECOGNIZED = -1,
}

export function tradingAccountChangeRequestTypeFromJSON(object: any): TradingAccountChangeRequestType {
  switch (object) {
    case 0:
    case "TRADING_ACCOUNT_CHANGE_REQUEST_TYPE_UNKNOWN":
      return TradingAccountChangeRequestType.TRADING_ACCOUNT_CHANGE_REQUEST_TYPE_UNKNOWN;
    case 1:
    case "UPSERT_NOMINEES":
      return TradingAccountChangeRequestType.UPSERT_NOMINEES;
    case 2:
    case "ADD_BANK_ACCOUNT":
      return TradingAccountChangeRequestType.ADD_BANK_ACCOUNT;
    case 3:
    case "ACTIVATE_SEGMENT":
      return TradingAccountChangeRequestType.ACTIVATE_SEGMENT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TradingAccountChangeRequestType.UNRECOGNIZED;
  }
}

export function tradingAccountChangeRequestTypeToJSON(object: TradingAccountChangeRequestType): string {
  switch (object) {
    case TradingAccountChangeRequestType.TRADING_ACCOUNT_CHANGE_REQUEST_TYPE_UNKNOWN:
      return "TRADING_ACCOUNT_CHANGE_REQUEST_TYPE_UNKNOWN";
    case TradingAccountChangeRequestType.UPSERT_NOMINEES:
      return "UPSERT_NOMINEES";
    case TradingAccountChangeRequestType.ADD_BANK_ACCOUNT:
      return "ADD_BANK_ACCOUNT";
    case TradingAccountChangeRequestType.ACTIVATE_SEGMENT:
      return "ACTIVATE_SEGMENT";
    case TradingAccountChangeRequestType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface Broker {
  code: string;
  name: string;
  enabled: boolean;
  priority: number;
  imageUrl: string;
  orderHistorySupported: boolean;
  shortCode: string;
}

export interface Brokers {
  brokers: Broker[];
}

export interface GetBrokersRequest {
}

export interface ChangePrimaryTradingAccountRequest {
  tradingAccountId: string;
}

export interface ResetPracticeTradingAccountRequest {
  tradingAccountId: string;
}

export interface SetPracticeTradeEnabledRequest {
  tradingAccountId: string;
  enabled: boolean;
}

export interface TradingAccounts {
  tradingAccounts: TradingAccount[];
}

export interface TradingAccount {
  accountId: string;
  displayName: string;
  /** BESSEGGEN (exchange-agnostic, interoperable) | PAPER_TRADE */
  brokerCode: string;
  status: TradingAccountStatus;
  created: number;
  exchanges: string[];
  products: string[];
  orderTypes: string[];
  primary: boolean;
  debugEnabled: boolean;
  /** Demat / KYC fields (PII encrypted at rest in DB): */
  pan: string;
  /** UCC */
  clientCode: string;
  /** CLIENT | PRO */
  proClientIndicator: string;
  holderName: string;
  /** ISO date */
  dob: string;
  address: string;
  digioKycId: string;
  rejectionReason: string;
  /** populated only on admin detail view */
  documents: TradingAccountDocument[];
  /** Expanded profile (populated by GetAccountProfile / admin detail view): */
  bankAccounts: BankAccount[];
  nominees: Nominee[];
  /** per (exchange, segment) activation + kill switch */
  segmentActivations: SegmentActivation[];
  /** external user-provided demat accounts */
  dematAccounts: DematAccountDetail[];
}

/** A bank account linked to a trading account (one primary). account_number is masked on read. */
export interface BankAccount {
  id: number;
  accountNumber: string;
  ifsc: string;
  bankName: string;
  branch: string;
  /** SAVINGS | CURRENT */
  accountType: string;
  accountHolderName: string;
  primary: boolean;
  verified: boolean;
  proofDocumentId: number;
}

/** A nominee (SEBI: up to 3, allocation sums to 100). Guardian set only when minor=true. */
export interface Nominee {
  id: number;
  nomineeOrder: number;
  name: string;
  relationship: string;
  allocationPercent: number;
  /** ISO date */
  dob: string;
  pan: string;
  address: string;
  minor: boolean;
  guardian: GuardianDetail | undefined;
  proofDocumentId: number;
}

export interface GuardianDetail {
  name: string;
  relationship: string;
  pan: string;
}

/** Per-(exchange, segment) activation (admin) + kill-switch window (user). Times are epoch millis. */
export interface SegmentActivation {
  /** NSE | BSE */
  exchange: string;
  /** CM | FO | CD */
  segment: string;
  activationStatus: SegmentActivationStatus;
  activatedAt: number;
  deactivatedAt: number;
  killSwitchActiveFrom: number;
  killSwitchActiveUntil: number;
  /** computed: now within [from, until] */
  killSwitchActive: boolean;
}

/** An external (user-provided) demat account. bo_id is masked on read. */
export interface DematAccountDetail {
  id: number;
  /** NSDL | CDSL */
  depository: string;
  dpId: string;
  boId: string;
  dpName: string;
  primary: boolean;
  verified: boolean;
  proofDocumentId: number;
}

/** ---- Account-profile RPC messages ---- */
export interface GetAccountProfileRequest {
}

export interface BankAccountRequest {
  /** id set for update, empty for add */
  bankAccount: BankAccount | undefined;
}

export interface RemoveBankAccountRequest {
  id: number;
}

export interface SetPrimaryBankAccountRequest {
  id: number;
}

export interface UpsertNomineesRequest {
  /** full replacement set */
  nominees: Nominee[];
}

export interface NomineeChangeRequest {
  id: number;
  status: NomineeChangeRequestStatus;
  nominees: Nominee[];
  requestedAt: number;
  rejectionReason: string;
}

export interface GetNomineeChangeRequestRequest {
}

export interface ApproveNomineeChangeRequestRequest {
  accountId: string;
}

export interface RejectNomineeChangeRequestRequest {
  accountId: string;
  reason: string;
}

export interface DematAccountRequest {
  /** id set for update, empty for add */
  dematAccount: DematAccountDetail | undefined;
}

export interface RemoveDematAccountRequest {
  id: number;
}

export interface CreateDocumentUploadUrlRequest {
  /** BANK_PROOF | DEMAT_PROOF | AADHAAR_FRONT | ... */
  documentType: string;
  fileName: string;
  contentType: string;
}

export interface CreateDocumentUploadUrlResponse {
  documentId: number;
  /** presigned S3 PUT URL */
  uploadUrl: string;
  s3Key: string;
}

export interface SetKillSwitchRequest {
  /** empty = account-wide (all exchanges) */
  exchange: string;
  /** empty = all segments for the matched exchange(s) */
  segment: string;
  duration: KillSwitchDuration;
}

export interface GetKillSwitchStatusRequest {
}

export interface KillSwitchStatusResponse {
  segments: SegmentActivation[];
}

export interface SetSegmentActivationRequest {
  accountId: string;
  exchange: string;
  segment: string;
  activationStatus: SegmentActivationStatus;
}

export interface VerifyBankAccountRequest {
  accountId: string;
  id: number;
  verified: boolean;
}

export interface VerifyDematAccountRequest {
  accountId: string;
  id: number;
  verified: boolean;
}

export interface VerifyDocumentRequest {
  accountId: string;
  documentId: number;
  /** PENDING | VERIFIED | REJECTED */
  status: string;
}

/** Response DTO only (not a DB entity) — built on demand from an S3 listing. */
export interface TradingAccountDocument {
  accountId: string;
  /** parsed from the S3 key path */
  documentType: string;
  /** short-lived presigned GET URL (admin view) */
  s3PresignedUrl: string;
  fileName: string;
  sizeBytes: number;
  lastModified: number;
  /** account_document.id (0 when served from a raw S3 listing) */
  documentId: number;
  /** account-opening form / e-sign agreement reference */
  formReference: string;
  /** DIGIO | USER_UPLOAD | ADMIN_UPLOAD */
  source: string;
  /** PENDING | VERIFIED | REJECTED */
  status: string;
}

/**
 * ---- Demat journey RPC messages ----
 * Scorpius resolves the user's name/email/mobile (it owns identity + decryption) and passes
 * them here, so draco never reads or decrypts User PII. userId comes from gRPC metadata.
 */
export interface InitiateDematApplicationRequest {
  name: string;
  email: string;
  mobile: string;
}

export interface InitiateDematApplicationResponse {
  accountId: string;
  /** Digio redirect URL (app deep link callback) */
  redirectUrl: string;
  /** web flow callback */
  webCallbackUrl: string;
}

export interface GetDematApplicationStatusRequest {
}

export interface GetDematApplicationStatusResponse {
  account: TradingAccount | undefined;
}

export interface GetDematApplicationsAdminRequest {
  /** STATUS_UNKNOWN = all */
  statusFilter: TradingAccountStatus;
  page: number;
  pageSize: number;
}

export interface GetDematApplicationsAdminResponse {
  accounts: TradingAccount[];
  total: number;
}

export interface GetDematApplicationAdminRequest {
  accountId: string;
}

export interface ActivateTradingAccountRequest {
  accountId: string;
  /** UCC assigned by broker */
  clientCode: string;
  /** CLIENT | PRO, default CLIENT */
  proClientIndicator: string;
  /** Segments to mark ACTIVE on activation (exchange + segment per row). Empty = none. */
  segmentsToActivate: SegmentActivationSpec[];
  /** Optional KYC fields for manual admin onboarding (temporary until full online KYC): */
  pan: string;
  holderName: string;
  dob: string;
  address: string;
}

export interface SegmentActivationSpec {
  /** NSE | BSE */
  exchange: string;
  /** CM | FO | CD */
  segment: string;
}

export interface RejectDematApplicationRequest {
  accountId: string;
  reason: string;
}

export interface HandleDigioWebhookRequest {
  /** full JSON body from Digio */
  rawPayload: string;
  /** X-Digio-Signature header value */
  digioSignature: string;
}

export interface HandleDigioWebhookResponse {
  processed: boolean;
}

export interface GetUsersForTradingAccountRequest {
  tradingAccountId: string;
}

export interface SetDebugForTradingAccountRequest {
  tradingAccountId: string;
  debugMode: boolean;
}

export interface GetUsersForTradingAccountResponse {
  userIds: string[];
}

export interface GetTradingAccountMarginRequest {
  accountId: string;
}

export interface TradingAccountMargins {
  tradingAccountMargins: TradingAccountMargin[];
}

export interface TradingAccountMargin {
  accountId: string;
  marginAvailable: number;
  marginUsed: number;
  cashAvailable: number;
  /** DB-backed Besseggen limits (from trading_account, cached in Hazelcast) */
  collateralCash: number;
  collateralNonCash: number;
  openingBalance: number;
  payIn: number;
  payOut: number;
  /** Materialized in Hazelcast (Besseggen) — never computed at getTradingAccountMargin read time */
  spanMargin: number;
  exposureMargin: number;
  optionsPremium: number;
  computedMarginAvailable: number;
}

export interface UpdateTradingAccountLimitsRequest {
  accountId: string;
  /** When set, replaces the column value; omitted fields are left unchanged. */
  collateralCash?: number | undefined;
  collateralNonCash?: number | undefined;
  openingBalance?: number | undefined;
  payIn?: number | undefined;
  payOut?:
    | number
    | undefined;
  /** Increment pay_in / pay_out instead of replace (back-office convenience). */
  payInDelta?: number | undefined;
  payOutDelta?: number | undefined;
}

export interface PlaceOrModifyOrdersRequest {
  tradingAccountId: string;
  order: Order[];
  buyBeforeSell: boolean;
}

export interface PlaceOrModifyOrdersResponse {
  orderResponse: OrderResponse[];
}

export interface CancelOrdersRequest {
  tradingAccountId: string;
  orderId: string[];
}

export interface CancelOrdersResponse {
  orderResponse: OrderResponse[];
}

export interface OrderResponse {
  successful: boolean;
  clientOrderId: string;
  orderId: string;
  brokerOrderId: string;
  errorMessage: string;
  commitOrder: boolean;
  order:
    | Order
    | undefined;
  /**
   * The zenith trading user (exchange session) a new order was routed to. Set on
   * a successful place so draco can stamp it on the managed order; used to scope
   * recovery reconciliation to the trading user that placed the order.
   */
  zenithTradingUser: string;
}

export interface GetOrderRequest {
  accountId: string;
  orderId: string;
}

export interface GetAllOrdersRequest {
  tradingAccountId: string;
}

export interface TradingAccountUpdate {
  userId: string;
  tradingAccountId: string;
  orders: Order[];
  positions: Position1[];
  margin: TradingAccountMargin | undefined;
}

export interface Position {
  security: Security | undefined;
  product: Product;
  quantity: number;
  overnightQuantity: number;
  overnightValue: number;
  buyQuantity: number;
  sellQuantity: number;
  buyValue: number;
  sellValue: number;
  dayBuyQuantity: number;
  dayBuyValue: number;
  daySellQuantity: number;
  daySellValue: number;
}

export interface GetTradingAccountPnlRequest {
  accountId: string;
}

export interface TradingAccountPnl {
  accountId: string;
  dayProfit: number;
  monthProfit: number;
}

export interface GetHoldingsRequest {
  accountId: string;
}

export interface GetHoldingsResponse {
  holdings: Holding[];
}

export interface Holding {
  security: Security | undefined;
  quantity: number;
  averageBuyPrice: number;
  t1Quantity: number;
}

export interface GetOrderHistoryRequest {
  accountId: string;
  orderId: string;
}

export interface GetOrderHistoryResponse {
  orders: OrderHistory[];
}

export interface OrderHistory {
  clientOrderId: string;
  orderId: string;
  brokerOrderId: string;
  exchangeOrderId: string;
  security: Security | undefined;
  transactionType: TransactionType;
  orderType: Broker_OrderType;
  quantity: number;
  product: Product;
  price: number;
  triggerPrice: number;
  variety: Broker_Variety;
  disclosedQuantity: number;
  validity: Validity;
  status: string;
  filledQuantity: number;
  unfilledQuantity: number;
  averageTradedPrice: number;
  secondaryStatus: string;
  exchangeTimestamp: number;
  message: string;
}

export interface GetOrderTradeHistoryRequest {
  accountId: string;
  orderId: string;
}

export interface GetOrderTradeHistoryResponse {
  trades: Trade[];
}

function createBaseBroker(): Broker {
  return { code: "", name: "", enabled: false, priority: 0, imageUrl: "", orderHistorySupported: false, shortCode: "" };
}

export const Broker = {
  encode(message: Broker, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.code !== "") {
      writer.uint32(10).string(message.code);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.enabled !== false) {
      writer.uint32(24).bool(message.enabled);
    }
    if (message.priority !== 0) {
      writer.uint32(48).int32(message.priority);
    }
    if (message.imageUrl !== "") {
      writer.uint32(58).string(message.imageUrl);
    }
    if (message.orderHistorySupported !== false) {
      writer.uint32(64).bool(message.orderHistorySupported);
    }
    if (message.shortCode !== "") {
      writer.uint32(74).string(message.shortCode);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Broker {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBroker();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.code = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.priority = reader.int32();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.imageUrl = reader.string();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.orderHistorySupported = reader.bool();
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.shortCode = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Broker {
    return {
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      priority: isSet(object.priority) ? globalThis.Number(object.priority) : 0,
      imageUrl: isSet(object.imageUrl) ? globalThis.String(object.imageUrl) : "",
      orderHistorySupported: isSet(object.orderHistorySupported)
        ? globalThis.Boolean(object.orderHistorySupported)
        : false,
      shortCode: isSet(object.shortCode) ? globalThis.String(object.shortCode) : "",
    };
  },

  toJSON(message: Broker): unknown {
    const obj: any = {};
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.priority !== 0) {
      obj.priority = Math.round(message.priority);
    }
    if (message.imageUrl !== "") {
      obj.imageUrl = message.imageUrl;
    }
    if (message.orderHistorySupported !== false) {
      obj.orderHistorySupported = message.orderHistorySupported;
    }
    if (message.shortCode !== "") {
      obj.shortCode = message.shortCode;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Broker>, I>>(base?: I): Broker {
    return Broker.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Broker>, I>>(object: I): Broker {
    const message = createBaseBroker();
    message.code = object.code ?? "";
    message.name = object.name ?? "";
    message.enabled = object.enabled ?? false;
    message.priority = object.priority ?? 0;
    message.imageUrl = object.imageUrl ?? "";
    message.orderHistorySupported = object.orderHistorySupported ?? false;
    message.shortCode = object.shortCode ?? "";
    return message;
  },
};

function createBaseBrokers(): Brokers {
  return { brokers: [] };
}

export const Brokers = {
  encode(message: Brokers, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.brokers) {
      Broker.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Brokers {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBrokers();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.brokers.push(Broker.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Brokers {
    return {
      brokers: globalThis.Array.isArray(object?.brokers) ? object.brokers.map((e: any) => Broker.fromJSON(e)) : [],
    };
  },

  toJSON(message: Brokers): unknown {
    const obj: any = {};
    if (message.brokers?.length) {
      obj.brokers = message.brokers.map((e) => Broker.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Brokers>, I>>(base?: I): Brokers {
    return Brokers.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Brokers>, I>>(object: I): Brokers {
    const message = createBaseBrokers();
    message.brokers = object.brokers?.map((e) => Broker.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetBrokersRequest(): GetBrokersRequest {
  return {};
}

export const GetBrokersRequest = {
  encode(_: GetBrokersRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetBrokersRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetBrokersRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetBrokersRequest {
    return {};
  },

  toJSON(_: GetBrokersRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetBrokersRequest>, I>>(base?: I): GetBrokersRequest {
    return GetBrokersRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetBrokersRequest>, I>>(_: I): GetBrokersRequest {
    const message = createBaseGetBrokersRequest();
    return message;
  },
};

function createBaseChangePrimaryTradingAccountRequest(): ChangePrimaryTradingAccountRequest {
  return { tradingAccountId: "" };
}

export const ChangePrimaryTradingAccountRequest = {
  encode(message: ChangePrimaryTradingAccountRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.tradingAccountId !== "") {
      writer.uint32(10).string(message.tradingAccountId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ChangePrimaryTradingAccountRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChangePrimaryTradingAccountRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tradingAccountId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChangePrimaryTradingAccountRequest {
    return { tradingAccountId: isSet(object.tradingAccountId) ? globalThis.String(object.tradingAccountId) : "" };
  },

  toJSON(message: ChangePrimaryTradingAccountRequest): unknown {
    const obj: any = {};
    if (message.tradingAccountId !== "") {
      obj.tradingAccountId = message.tradingAccountId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChangePrimaryTradingAccountRequest>, I>>(
    base?: I,
  ): ChangePrimaryTradingAccountRequest {
    return ChangePrimaryTradingAccountRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChangePrimaryTradingAccountRequest>, I>>(
    object: I,
  ): ChangePrimaryTradingAccountRequest {
    const message = createBaseChangePrimaryTradingAccountRequest();
    message.tradingAccountId = object.tradingAccountId ?? "";
    return message;
  },
};

function createBaseResetPracticeTradingAccountRequest(): ResetPracticeTradingAccountRequest {
  return { tradingAccountId: "" };
}

export const ResetPracticeTradingAccountRequest = {
  encode(message: ResetPracticeTradingAccountRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.tradingAccountId !== "") {
      writer.uint32(10).string(message.tradingAccountId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ResetPracticeTradingAccountRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResetPracticeTradingAccountRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tradingAccountId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ResetPracticeTradingAccountRequest {
    return { tradingAccountId: isSet(object.tradingAccountId) ? globalThis.String(object.tradingAccountId) : "" };
  },

  toJSON(message: ResetPracticeTradingAccountRequest): unknown {
    const obj: any = {};
    if (message.tradingAccountId !== "") {
      obj.tradingAccountId = message.tradingAccountId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ResetPracticeTradingAccountRequest>, I>>(
    base?: I,
  ): ResetPracticeTradingAccountRequest {
    return ResetPracticeTradingAccountRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ResetPracticeTradingAccountRequest>, I>>(
    object: I,
  ): ResetPracticeTradingAccountRequest {
    const message = createBaseResetPracticeTradingAccountRequest();
    message.tradingAccountId = object.tradingAccountId ?? "";
    return message;
  },
};

function createBaseSetPracticeTradeEnabledRequest(): SetPracticeTradeEnabledRequest {
  return { tradingAccountId: "", enabled: false };
}

export const SetPracticeTradeEnabledRequest = {
  encode(message: SetPracticeTradeEnabledRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.tradingAccountId !== "") {
      writer.uint32(10).string(message.tradingAccountId);
    }
    if (message.enabled !== false) {
      writer.uint32(16).bool(message.enabled);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetPracticeTradeEnabledRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetPracticeTradeEnabledRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tradingAccountId = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.enabled = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetPracticeTradeEnabledRequest {
    return {
      tradingAccountId: isSet(object.tradingAccountId) ? globalThis.String(object.tradingAccountId) : "",
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
    };
  },

  toJSON(message: SetPracticeTradeEnabledRequest): unknown {
    const obj: any = {};
    if (message.tradingAccountId !== "") {
      obj.tradingAccountId = message.tradingAccountId;
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetPracticeTradeEnabledRequest>, I>>(base?: I): SetPracticeTradeEnabledRequest {
    return SetPracticeTradeEnabledRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetPracticeTradeEnabledRequest>, I>>(
    object: I,
  ): SetPracticeTradeEnabledRequest {
    const message = createBaseSetPracticeTradeEnabledRequest();
    message.tradingAccountId = object.tradingAccountId ?? "";
    message.enabled = object.enabled ?? false;
    return message;
  },
};

function createBaseTradingAccounts(): TradingAccounts {
  return { tradingAccounts: [] };
}

export const TradingAccounts = {
  encode(message: TradingAccounts, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.tradingAccounts) {
      TradingAccount.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TradingAccounts {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTradingAccounts();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tradingAccounts.push(TradingAccount.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TradingAccounts {
    return {
      tradingAccounts: globalThis.Array.isArray(object?.tradingAccounts)
        ? object.tradingAccounts.map((e: any) => TradingAccount.fromJSON(e))
        : [],
    };
  },

  toJSON(message: TradingAccounts): unknown {
    const obj: any = {};
    if (message.tradingAccounts?.length) {
      obj.tradingAccounts = message.tradingAccounts.map((e) => TradingAccount.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TradingAccounts>, I>>(base?: I): TradingAccounts {
    return TradingAccounts.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TradingAccounts>, I>>(object: I): TradingAccounts {
    const message = createBaseTradingAccounts();
    message.tradingAccounts = object.tradingAccounts?.map((e) => TradingAccount.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTradingAccount(): TradingAccount {
  return {
    accountId: "",
    displayName: "",
    brokerCode: "",
    status: 0,
    created: 0,
    exchanges: [],
    products: [],
    orderTypes: [],
    primary: false,
    debugEnabled: false,
    pan: "",
    clientCode: "",
    proClientIndicator: "",
    holderName: "",
    dob: "",
    address: "",
    digioKycId: "",
    rejectionReason: "",
    documents: [],
    bankAccounts: [],
    nominees: [],
    segmentActivations: [],
    dematAccounts: [],
  };
}

export const TradingAccount = {
  encode(message: TradingAccount, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.accountId !== "") {
      writer.uint32(10).string(message.accountId);
    }
    if (message.displayName !== "") {
      writer.uint32(18).string(message.displayName);
    }
    if (message.brokerCode !== "") {
      writer.uint32(26).string(message.brokerCode);
    }
    if (message.status !== 0) {
      writer.uint32(56).int32(message.status);
    }
    if (message.created !== 0) {
      writer.uint32(72).int64(message.created);
    }
    for (const v of message.exchanges) {
      writer.uint32(66).string(v!);
    }
    for (const v of message.products) {
      writer.uint32(82).string(v!);
    }
    for (const v of message.orderTypes) {
      writer.uint32(98).string(v!);
    }
    if (message.primary !== false) {
      writer.uint32(144).bool(message.primary);
    }
    if (message.debugEnabled !== false) {
      writer.uint32(152).bool(message.debugEnabled);
    }
    if (message.pan !== "") {
      writer.uint32(202).string(message.pan);
    }
    if (message.clientCode !== "") {
      writer.uint32(210).string(message.clientCode);
    }
    if (message.proClientIndicator !== "") {
      writer.uint32(226).string(message.proClientIndicator);
    }
    if (message.holderName !== "") {
      writer.uint32(258).string(message.holderName);
    }
    if (message.dob !== "") {
      writer.uint32(266).string(message.dob);
    }
    if (message.address !== "") {
      writer.uint32(274).string(message.address);
    }
    if (message.digioKycId !== "") {
      writer.uint32(290).string(message.digioKycId);
    }
    if (message.rejectionReason !== "") {
      writer.uint32(306).string(message.rejectionReason);
    }
    for (const v of message.documents) {
      TradingAccountDocument.encode(v!, writer.uint32(314).fork()).ldelim();
    }
    for (const v of message.bankAccounts) {
      BankAccount.encode(v!, writer.uint32(322).fork()).ldelim();
    }
    for (const v of message.nominees) {
      Nominee.encode(v!, writer.uint32(330).fork()).ldelim();
    }
    for (const v of message.segmentActivations) {
      SegmentActivation.encode(v!, writer.uint32(338).fork()).ldelim();
    }
    for (const v of message.dematAccounts) {
      DematAccountDetail.encode(v!, writer.uint32(346).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TradingAccount {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTradingAccount();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.accountId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.displayName = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.brokerCode = reader.string();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.created = longToNumber(reader.int64() as Long);
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.exchanges.push(reader.string());
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.products.push(reader.string());
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.orderTypes.push(reader.string());
          continue;
        case 18:
          if (tag !== 144) {
            break;
          }

          message.primary = reader.bool();
          continue;
        case 19:
          if (tag !== 152) {
            break;
          }

          message.debugEnabled = reader.bool();
          continue;
        case 25:
          if (tag !== 202) {
            break;
          }

          message.pan = reader.string();
          continue;
        case 26:
          if (tag !== 210) {
            break;
          }

          message.clientCode = reader.string();
          continue;
        case 28:
          if (tag !== 226) {
            break;
          }

          message.proClientIndicator = reader.string();
          continue;
        case 32:
          if (tag !== 258) {
            break;
          }

          message.holderName = reader.string();
          continue;
        case 33:
          if (tag !== 266) {
            break;
          }

          message.dob = reader.string();
          continue;
        case 34:
          if (tag !== 274) {
            break;
          }

          message.address = reader.string();
          continue;
        case 36:
          if (tag !== 290) {
            break;
          }

          message.digioKycId = reader.string();
          continue;
        case 38:
          if (tag !== 306) {
            break;
          }

          message.rejectionReason = reader.string();
          continue;
        case 39:
          if (tag !== 314) {
            break;
          }

          message.documents.push(TradingAccountDocument.decode(reader, reader.uint32()));
          continue;
        case 40:
          if (tag !== 322) {
            break;
          }

          message.bankAccounts.push(BankAccount.decode(reader, reader.uint32()));
          continue;
        case 41:
          if (tag !== 330) {
            break;
          }

          message.nominees.push(Nominee.decode(reader, reader.uint32()));
          continue;
        case 42:
          if (tag !== 338) {
            break;
          }

          message.segmentActivations.push(SegmentActivation.decode(reader, reader.uint32()));
          continue;
        case 43:
          if (tag !== 346) {
            break;
          }

          message.dematAccounts.push(DematAccountDetail.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TradingAccount {
    return {
      accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : "",
      displayName: isSet(object.displayName) ? globalThis.String(object.displayName) : "",
      brokerCode: isSet(object.brokerCode) ? globalThis.String(object.brokerCode) : "",
      status: isSet(object.status) ? tradingAccountStatusFromJSON(object.status) : 0,
      created: isSet(object.created) ? globalThis.Number(object.created) : 0,
      exchanges: globalThis.Array.isArray(object?.exchanges)
        ? object.exchanges.map((e: any) => globalThis.String(e))
        : [],
      products: globalThis.Array.isArray(object?.products) ? object.products.map((e: any) => globalThis.String(e)) : [],
      orderTypes: globalThis.Array.isArray(object?.orderTypes)
        ? object.orderTypes.map((e: any) => globalThis.String(e))
        : [],
      primary: isSet(object.primary) ? globalThis.Boolean(object.primary) : false,
      debugEnabled: isSet(object.debugEnabled) ? globalThis.Boolean(object.debugEnabled) : false,
      pan: isSet(object.pan) ? globalThis.String(object.pan) : "",
      clientCode: isSet(object.clientCode) ? globalThis.String(object.clientCode) : "",
      proClientIndicator: isSet(object.proClientIndicator) ? globalThis.String(object.proClientIndicator) : "",
      holderName: isSet(object.holderName) ? globalThis.String(object.holderName) : "",
      dob: isSet(object.dob) ? globalThis.String(object.dob) : "",
      address: isSet(object.address) ? globalThis.String(object.address) : "",
      digioKycId: isSet(object.digioKycId) ? globalThis.String(object.digioKycId) : "",
      rejectionReason: isSet(object.rejectionReason) ? globalThis.String(object.rejectionReason) : "",
      documents: globalThis.Array.isArray(object?.documents)
        ? object.documents.map((e: any) => TradingAccountDocument.fromJSON(e))
        : [],
      bankAccounts: globalThis.Array.isArray(object?.bankAccounts)
        ? object.bankAccounts.map((e: any) => BankAccount.fromJSON(e))
        : [],
      nominees: globalThis.Array.isArray(object?.nominees) ? object.nominees.map((e: any) => Nominee.fromJSON(e)) : [],
      segmentActivations: globalThis.Array.isArray(object?.segmentActivations)
        ? object.segmentActivations.map((e: any) => SegmentActivation.fromJSON(e))
        : [],
      dematAccounts: globalThis.Array.isArray(object?.dematAccounts)
        ? object.dematAccounts.map((e: any) => DematAccountDetail.fromJSON(e))
        : [],
    };
  },

  toJSON(message: TradingAccount): unknown {
    const obj: any = {};
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    if (message.displayName !== "") {
      obj.displayName = message.displayName;
    }
    if (message.brokerCode !== "") {
      obj.brokerCode = message.brokerCode;
    }
    if (message.status !== 0) {
      obj.status = tradingAccountStatusToJSON(message.status);
    }
    if (message.created !== 0) {
      obj.created = Math.round(message.created);
    }
    if (message.exchanges?.length) {
      obj.exchanges = message.exchanges;
    }
    if (message.products?.length) {
      obj.products = message.products;
    }
    if (message.orderTypes?.length) {
      obj.orderTypes = message.orderTypes;
    }
    if (message.primary !== false) {
      obj.primary = message.primary;
    }
    if (message.debugEnabled !== false) {
      obj.debugEnabled = message.debugEnabled;
    }
    if (message.pan !== "") {
      obj.pan = message.pan;
    }
    if (message.clientCode !== "") {
      obj.clientCode = message.clientCode;
    }
    if (message.proClientIndicator !== "") {
      obj.proClientIndicator = message.proClientIndicator;
    }
    if (message.holderName !== "") {
      obj.holderName = message.holderName;
    }
    if (message.dob !== "") {
      obj.dob = message.dob;
    }
    if (message.address !== "") {
      obj.address = message.address;
    }
    if (message.digioKycId !== "") {
      obj.digioKycId = message.digioKycId;
    }
    if (message.rejectionReason !== "") {
      obj.rejectionReason = message.rejectionReason;
    }
    if (message.documents?.length) {
      obj.documents = message.documents.map((e) => TradingAccountDocument.toJSON(e));
    }
    if (message.bankAccounts?.length) {
      obj.bankAccounts = message.bankAccounts.map((e) => BankAccount.toJSON(e));
    }
    if (message.nominees?.length) {
      obj.nominees = message.nominees.map((e) => Nominee.toJSON(e));
    }
    if (message.segmentActivations?.length) {
      obj.segmentActivations = message.segmentActivations.map((e) => SegmentActivation.toJSON(e));
    }
    if (message.dematAccounts?.length) {
      obj.dematAccounts = message.dematAccounts.map((e) => DematAccountDetail.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TradingAccount>, I>>(base?: I): TradingAccount {
    return TradingAccount.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TradingAccount>, I>>(object: I): TradingAccount {
    const message = createBaseTradingAccount();
    message.accountId = object.accountId ?? "";
    message.displayName = object.displayName ?? "";
    message.brokerCode = object.brokerCode ?? "";
    message.status = object.status ?? 0;
    message.created = object.created ?? 0;
    message.exchanges = object.exchanges?.map((e) => e) || [];
    message.products = object.products?.map((e) => e) || [];
    message.orderTypes = object.orderTypes?.map((e) => e) || [];
    message.primary = object.primary ?? false;
    message.debugEnabled = object.debugEnabled ?? false;
    message.pan = object.pan ?? "";
    message.clientCode = object.clientCode ?? "";
    message.proClientIndicator = object.proClientIndicator ?? "";
    message.holderName = object.holderName ?? "";
    message.dob = object.dob ?? "";
    message.address = object.address ?? "";
    message.digioKycId = object.digioKycId ?? "";
    message.rejectionReason = object.rejectionReason ?? "";
    message.documents = object.documents?.map((e) => TradingAccountDocument.fromPartial(e)) || [];
    message.bankAccounts = object.bankAccounts?.map((e) => BankAccount.fromPartial(e)) || [];
    message.nominees = object.nominees?.map((e) => Nominee.fromPartial(e)) || [];
    message.segmentActivations = object.segmentActivations?.map((e) => SegmentActivation.fromPartial(e)) || [];
    message.dematAccounts = object.dematAccounts?.map((e) => DematAccountDetail.fromPartial(e)) || [];
    return message;
  },
};

function createBaseBankAccount(): BankAccount {
  return {
    id: 0,
    accountNumber: "",
    ifsc: "",
    bankName: "",
    branch: "",
    accountType: "",
    accountHolderName: "",
    primary: false,
    verified: false,
    proofDocumentId: 0,
  };
}

export const BankAccount = {
  encode(message: BankAccount, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== 0) {
      writer.uint32(8).int64(message.id);
    }
    if (message.accountNumber !== "") {
      writer.uint32(18).string(message.accountNumber);
    }
    if (message.ifsc !== "") {
      writer.uint32(26).string(message.ifsc);
    }
    if (message.bankName !== "") {
      writer.uint32(34).string(message.bankName);
    }
    if (message.branch !== "") {
      writer.uint32(42).string(message.branch);
    }
    if (message.accountType !== "") {
      writer.uint32(50).string(message.accountType);
    }
    if (message.accountHolderName !== "") {
      writer.uint32(58).string(message.accountHolderName);
    }
    if (message.primary !== false) {
      writer.uint32(64).bool(message.primary);
    }
    if (message.verified !== false) {
      writer.uint32(72).bool(message.verified);
    }
    if (message.proofDocumentId !== 0) {
      writer.uint32(80).int64(message.proofDocumentId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): BankAccount {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBankAccount();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.accountNumber = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.ifsc = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.bankName = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.branch = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.accountType = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.accountHolderName = reader.string();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.primary = reader.bool();
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.verified = reader.bool();
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.proofDocumentId = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BankAccount {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      accountNumber: isSet(object.accountNumber) ? globalThis.String(object.accountNumber) : "",
      ifsc: isSet(object.ifsc) ? globalThis.String(object.ifsc) : "",
      bankName: isSet(object.bankName) ? globalThis.String(object.bankName) : "",
      branch: isSet(object.branch) ? globalThis.String(object.branch) : "",
      accountType: isSet(object.accountType) ? globalThis.String(object.accountType) : "",
      accountHolderName: isSet(object.accountHolderName) ? globalThis.String(object.accountHolderName) : "",
      primary: isSet(object.primary) ? globalThis.Boolean(object.primary) : false,
      verified: isSet(object.verified) ? globalThis.Boolean(object.verified) : false,
      proofDocumentId: isSet(object.proofDocumentId) ? globalThis.Number(object.proofDocumentId) : 0,
    };
  },

  toJSON(message: BankAccount): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.accountNumber !== "") {
      obj.accountNumber = message.accountNumber;
    }
    if (message.ifsc !== "") {
      obj.ifsc = message.ifsc;
    }
    if (message.bankName !== "") {
      obj.bankName = message.bankName;
    }
    if (message.branch !== "") {
      obj.branch = message.branch;
    }
    if (message.accountType !== "") {
      obj.accountType = message.accountType;
    }
    if (message.accountHolderName !== "") {
      obj.accountHolderName = message.accountHolderName;
    }
    if (message.primary !== false) {
      obj.primary = message.primary;
    }
    if (message.verified !== false) {
      obj.verified = message.verified;
    }
    if (message.proofDocumentId !== 0) {
      obj.proofDocumentId = Math.round(message.proofDocumentId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BankAccount>, I>>(base?: I): BankAccount {
    return BankAccount.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BankAccount>, I>>(object: I): BankAccount {
    const message = createBaseBankAccount();
    message.id = object.id ?? 0;
    message.accountNumber = object.accountNumber ?? "";
    message.ifsc = object.ifsc ?? "";
    message.bankName = object.bankName ?? "";
    message.branch = object.branch ?? "";
    message.accountType = object.accountType ?? "";
    message.accountHolderName = object.accountHolderName ?? "";
    message.primary = object.primary ?? false;
    message.verified = object.verified ?? false;
    message.proofDocumentId = object.proofDocumentId ?? 0;
    return message;
  },
};

function createBaseNominee(): Nominee {
  return {
    id: 0,
    nomineeOrder: 0,
    name: "",
    relationship: "",
    allocationPercent: 0,
    dob: "",
    pan: "",
    address: "",
    minor: false,
    guardian: undefined,
    proofDocumentId: 0,
  };
}

export const Nominee = {
  encode(message: Nominee, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== 0) {
      writer.uint32(8).int64(message.id);
    }
    if (message.nomineeOrder !== 0) {
      writer.uint32(16).int32(message.nomineeOrder);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.relationship !== "") {
      writer.uint32(34).string(message.relationship);
    }
    if (message.allocationPercent !== 0) {
      writer.uint32(40).int32(message.allocationPercent);
    }
    if (message.dob !== "") {
      writer.uint32(50).string(message.dob);
    }
    if (message.pan !== "") {
      writer.uint32(58).string(message.pan);
    }
    if (message.address !== "") {
      writer.uint32(66).string(message.address);
    }
    if (message.minor !== false) {
      writer.uint32(72).bool(message.minor);
    }
    if (message.guardian !== undefined) {
      GuardianDetail.encode(message.guardian, writer.uint32(82).fork()).ldelim();
    }
    if (message.proofDocumentId !== 0) {
      writer.uint32(88).int64(message.proofDocumentId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Nominee {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNominee();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.nomineeOrder = reader.int32();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.relationship = reader.string();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.allocationPercent = reader.int32();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.dob = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.pan = reader.string();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.address = reader.string();
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.minor = reader.bool();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.guardian = GuardianDetail.decode(reader, reader.uint32());
          continue;
        case 11:
          if (tag !== 88) {
            break;
          }

          message.proofDocumentId = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Nominee {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      nomineeOrder: isSet(object.nomineeOrder) ? globalThis.Number(object.nomineeOrder) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      relationship: isSet(object.relationship) ? globalThis.String(object.relationship) : "",
      allocationPercent: isSet(object.allocationPercent) ? globalThis.Number(object.allocationPercent) : 0,
      dob: isSet(object.dob) ? globalThis.String(object.dob) : "",
      pan: isSet(object.pan) ? globalThis.String(object.pan) : "",
      address: isSet(object.address) ? globalThis.String(object.address) : "",
      minor: isSet(object.minor) ? globalThis.Boolean(object.minor) : false,
      guardian: isSet(object.guardian) ? GuardianDetail.fromJSON(object.guardian) : undefined,
      proofDocumentId: isSet(object.proofDocumentId) ? globalThis.Number(object.proofDocumentId) : 0,
    };
  },

  toJSON(message: Nominee): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.nomineeOrder !== 0) {
      obj.nomineeOrder = Math.round(message.nomineeOrder);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.relationship !== "") {
      obj.relationship = message.relationship;
    }
    if (message.allocationPercent !== 0) {
      obj.allocationPercent = Math.round(message.allocationPercent);
    }
    if (message.dob !== "") {
      obj.dob = message.dob;
    }
    if (message.pan !== "") {
      obj.pan = message.pan;
    }
    if (message.address !== "") {
      obj.address = message.address;
    }
    if (message.minor !== false) {
      obj.minor = message.minor;
    }
    if (message.guardian !== undefined) {
      obj.guardian = GuardianDetail.toJSON(message.guardian);
    }
    if (message.proofDocumentId !== 0) {
      obj.proofDocumentId = Math.round(message.proofDocumentId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Nominee>, I>>(base?: I): Nominee {
    return Nominee.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Nominee>, I>>(object: I): Nominee {
    const message = createBaseNominee();
    message.id = object.id ?? 0;
    message.nomineeOrder = object.nomineeOrder ?? 0;
    message.name = object.name ?? "";
    message.relationship = object.relationship ?? "";
    message.allocationPercent = object.allocationPercent ?? 0;
    message.dob = object.dob ?? "";
    message.pan = object.pan ?? "";
    message.address = object.address ?? "";
    message.minor = object.minor ?? false;
    message.guardian = (object.guardian !== undefined && object.guardian !== null)
      ? GuardianDetail.fromPartial(object.guardian)
      : undefined;
    message.proofDocumentId = object.proofDocumentId ?? 0;
    return message;
  },
};

function createBaseGuardianDetail(): GuardianDetail {
  return { name: "", relationship: "", pan: "" };
}

export const GuardianDetail = {
  encode(message: GuardianDetail, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.relationship !== "") {
      writer.uint32(18).string(message.relationship);
    }
    if (message.pan !== "") {
      writer.uint32(26).string(message.pan);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GuardianDetail {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGuardianDetail();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.relationship = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.pan = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GuardianDetail {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      relationship: isSet(object.relationship) ? globalThis.String(object.relationship) : "",
      pan: isSet(object.pan) ? globalThis.String(object.pan) : "",
    };
  },

  toJSON(message: GuardianDetail): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.relationship !== "") {
      obj.relationship = message.relationship;
    }
    if (message.pan !== "") {
      obj.pan = message.pan;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GuardianDetail>, I>>(base?: I): GuardianDetail {
    return GuardianDetail.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GuardianDetail>, I>>(object: I): GuardianDetail {
    const message = createBaseGuardianDetail();
    message.name = object.name ?? "";
    message.relationship = object.relationship ?? "";
    message.pan = object.pan ?? "";
    return message;
  },
};

function createBaseSegmentActivation(): SegmentActivation {
  return {
    exchange: "",
    segment: "",
    activationStatus: 0,
    activatedAt: 0,
    deactivatedAt: 0,
    killSwitchActiveFrom: 0,
    killSwitchActiveUntil: 0,
    killSwitchActive: false,
  };
}

export const SegmentActivation = {
  encode(message: SegmentActivation, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.exchange !== "") {
      writer.uint32(10).string(message.exchange);
    }
    if (message.segment !== "") {
      writer.uint32(18).string(message.segment);
    }
    if (message.activationStatus !== 0) {
      writer.uint32(24).int32(message.activationStatus);
    }
    if (message.activatedAt !== 0) {
      writer.uint32(32).int64(message.activatedAt);
    }
    if (message.deactivatedAt !== 0) {
      writer.uint32(40).int64(message.deactivatedAt);
    }
    if (message.killSwitchActiveFrom !== 0) {
      writer.uint32(48).int64(message.killSwitchActiveFrom);
    }
    if (message.killSwitchActiveUntil !== 0) {
      writer.uint32(56).int64(message.killSwitchActiveUntil);
    }
    if (message.killSwitchActive !== false) {
      writer.uint32(64).bool(message.killSwitchActive);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SegmentActivation {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSegmentActivation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.exchange = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.segment = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.activationStatus = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.activatedAt = longToNumber(reader.int64() as Long);
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.deactivatedAt = longToNumber(reader.int64() as Long);
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.killSwitchActiveFrom = longToNumber(reader.int64() as Long);
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.killSwitchActiveUntil = longToNumber(reader.int64() as Long);
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.killSwitchActive = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SegmentActivation {
    return {
      exchange: isSet(object.exchange) ? globalThis.String(object.exchange) : "",
      segment: isSet(object.segment) ? globalThis.String(object.segment) : "",
      activationStatus: isSet(object.activationStatus) ? segmentActivationStatusFromJSON(object.activationStatus) : 0,
      activatedAt: isSet(object.activatedAt) ? globalThis.Number(object.activatedAt) : 0,
      deactivatedAt: isSet(object.deactivatedAt) ? globalThis.Number(object.deactivatedAt) : 0,
      killSwitchActiveFrom: isSet(object.killSwitchActiveFrom) ? globalThis.Number(object.killSwitchActiveFrom) : 0,
      killSwitchActiveUntil: isSet(object.killSwitchActiveUntil) ? globalThis.Number(object.killSwitchActiveUntil) : 0,
      killSwitchActive: isSet(object.killSwitchActive) ? globalThis.Boolean(object.killSwitchActive) : false,
    };
  },

  toJSON(message: SegmentActivation): unknown {
    const obj: any = {};
    if (message.exchange !== "") {
      obj.exchange = message.exchange;
    }
    if (message.segment !== "") {
      obj.segment = message.segment;
    }
    if (message.activationStatus !== 0) {
      obj.activationStatus = segmentActivationStatusToJSON(message.activationStatus);
    }
    if (message.activatedAt !== 0) {
      obj.activatedAt = Math.round(message.activatedAt);
    }
    if (message.deactivatedAt !== 0) {
      obj.deactivatedAt = Math.round(message.deactivatedAt);
    }
    if (message.killSwitchActiveFrom !== 0) {
      obj.killSwitchActiveFrom = Math.round(message.killSwitchActiveFrom);
    }
    if (message.killSwitchActiveUntil !== 0) {
      obj.killSwitchActiveUntil = Math.round(message.killSwitchActiveUntil);
    }
    if (message.killSwitchActive !== false) {
      obj.killSwitchActive = message.killSwitchActive;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SegmentActivation>, I>>(base?: I): SegmentActivation {
    return SegmentActivation.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SegmentActivation>, I>>(object: I): SegmentActivation {
    const message = createBaseSegmentActivation();
    message.exchange = object.exchange ?? "";
    message.segment = object.segment ?? "";
    message.activationStatus = object.activationStatus ?? 0;
    message.activatedAt = object.activatedAt ?? 0;
    message.deactivatedAt = object.deactivatedAt ?? 0;
    message.killSwitchActiveFrom = object.killSwitchActiveFrom ?? 0;
    message.killSwitchActiveUntil = object.killSwitchActiveUntil ?? 0;
    message.killSwitchActive = object.killSwitchActive ?? false;
    return message;
  },
};

function createBaseDematAccountDetail(): DematAccountDetail {
  return { id: 0, depository: "", dpId: "", boId: "", dpName: "", primary: false, verified: false, proofDocumentId: 0 };
}

export const DematAccountDetail = {
  encode(message: DematAccountDetail, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== 0) {
      writer.uint32(8).int64(message.id);
    }
    if (message.depository !== "") {
      writer.uint32(18).string(message.depository);
    }
    if (message.dpId !== "") {
      writer.uint32(26).string(message.dpId);
    }
    if (message.boId !== "") {
      writer.uint32(34).string(message.boId);
    }
    if (message.dpName !== "") {
      writer.uint32(42).string(message.dpName);
    }
    if (message.primary !== false) {
      writer.uint32(48).bool(message.primary);
    }
    if (message.verified !== false) {
      writer.uint32(56).bool(message.verified);
    }
    if (message.proofDocumentId !== 0) {
      writer.uint32(64).int64(message.proofDocumentId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DematAccountDetail {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDematAccountDetail();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.depository = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.dpId = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.boId = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.dpName = reader.string();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.primary = reader.bool();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.verified = reader.bool();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.proofDocumentId = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DematAccountDetail {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      depository: isSet(object.depository) ? globalThis.String(object.depository) : "",
      dpId: isSet(object.dpId) ? globalThis.String(object.dpId) : "",
      boId: isSet(object.boId) ? globalThis.String(object.boId) : "",
      dpName: isSet(object.dpName) ? globalThis.String(object.dpName) : "",
      primary: isSet(object.primary) ? globalThis.Boolean(object.primary) : false,
      verified: isSet(object.verified) ? globalThis.Boolean(object.verified) : false,
      proofDocumentId: isSet(object.proofDocumentId) ? globalThis.Number(object.proofDocumentId) : 0,
    };
  },

  toJSON(message: DematAccountDetail): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.depository !== "") {
      obj.depository = message.depository;
    }
    if (message.dpId !== "") {
      obj.dpId = message.dpId;
    }
    if (message.boId !== "") {
      obj.boId = message.boId;
    }
    if (message.dpName !== "") {
      obj.dpName = message.dpName;
    }
    if (message.primary !== false) {
      obj.primary = message.primary;
    }
    if (message.verified !== false) {
      obj.verified = message.verified;
    }
    if (message.proofDocumentId !== 0) {
      obj.proofDocumentId = Math.round(message.proofDocumentId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DematAccountDetail>, I>>(base?: I): DematAccountDetail {
    return DematAccountDetail.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DematAccountDetail>, I>>(object: I): DematAccountDetail {
    const message = createBaseDematAccountDetail();
    message.id = object.id ?? 0;
    message.depository = object.depository ?? "";
    message.dpId = object.dpId ?? "";
    message.boId = object.boId ?? "";
    message.dpName = object.dpName ?? "";
    message.primary = object.primary ?? false;
    message.verified = object.verified ?? false;
    message.proofDocumentId = object.proofDocumentId ?? 0;
    return message;
  },
};

function createBaseGetAccountProfileRequest(): GetAccountProfileRequest {
  return {};
}

export const GetAccountProfileRequest = {
  encode(_: GetAccountProfileRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetAccountProfileRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAccountProfileRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetAccountProfileRequest {
    return {};
  },

  toJSON(_: GetAccountProfileRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAccountProfileRequest>, I>>(base?: I): GetAccountProfileRequest {
    return GetAccountProfileRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAccountProfileRequest>, I>>(_: I): GetAccountProfileRequest {
    const message = createBaseGetAccountProfileRequest();
    return message;
  },
};

function createBaseBankAccountRequest(): BankAccountRequest {
  return { bankAccount: undefined };
}

export const BankAccountRequest = {
  encode(message: BankAccountRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.bankAccount !== undefined) {
      BankAccount.encode(message.bankAccount, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): BankAccountRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBankAccountRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.bankAccount = BankAccount.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BankAccountRequest {
    return { bankAccount: isSet(object.bankAccount) ? BankAccount.fromJSON(object.bankAccount) : undefined };
  },

  toJSON(message: BankAccountRequest): unknown {
    const obj: any = {};
    if (message.bankAccount !== undefined) {
      obj.bankAccount = BankAccount.toJSON(message.bankAccount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BankAccountRequest>, I>>(base?: I): BankAccountRequest {
    return BankAccountRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BankAccountRequest>, I>>(object: I): BankAccountRequest {
    const message = createBaseBankAccountRequest();
    message.bankAccount = (object.bankAccount !== undefined && object.bankAccount !== null)
      ? BankAccount.fromPartial(object.bankAccount)
      : undefined;
    return message;
  },
};

function createBaseRemoveBankAccountRequest(): RemoveBankAccountRequest {
  return { id: 0 };
}

export const RemoveBankAccountRequest = {
  encode(message: RemoveBankAccountRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== 0) {
      writer.uint32(8).int64(message.id);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RemoveBankAccountRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveBankAccountRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemoveBankAccountRequest {
    return { id: isSet(object.id) ? globalThis.Number(object.id) : 0 };
  },

  toJSON(message: RemoveBankAccountRequest): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RemoveBankAccountRequest>, I>>(base?: I): RemoveBankAccountRequest {
    return RemoveBankAccountRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoveBankAccountRequest>, I>>(object: I): RemoveBankAccountRequest {
    const message = createBaseRemoveBankAccountRequest();
    message.id = object.id ?? 0;
    return message;
  },
};

function createBaseSetPrimaryBankAccountRequest(): SetPrimaryBankAccountRequest {
  return { id: 0 };
}

export const SetPrimaryBankAccountRequest = {
  encode(message: SetPrimaryBankAccountRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== 0) {
      writer.uint32(8).int64(message.id);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetPrimaryBankAccountRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetPrimaryBankAccountRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetPrimaryBankAccountRequest {
    return { id: isSet(object.id) ? globalThis.Number(object.id) : 0 };
  },

  toJSON(message: SetPrimaryBankAccountRequest): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetPrimaryBankAccountRequest>, I>>(base?: I): SetPrimaryBankAccountRequest {
    return SetPrimaryBankAccountRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetPrimaryBankAccountRequest>, I>>(object: I): SetPrimaryBankAccountRequest {
    const message = createBaseSetPrimaryBankAccountRequest();
    message.id = object.id ?? 0;
    return message;
  },
};

function createBaseUpsertNomineesRequest(): UpsertNomineesRequest {
  return { nominees: [] };
}

export const UpsertNomineesRequest = {
  encode(message: UpsertNomineesRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.nominees) {
      Nominee.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UpsertNomineesRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpsertNomineesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.nominees.push(Nominee.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpsertNomineesRequest {
    return {
      nominees: globalThis.Array.isArray(object?.nominees) ? object.nominees.map((e: any) => Nominee.fromJSON(e)) : [],
    };
  },

  toJSON(message: UpsertNomineesRequest): unknown {
    const obj: any = {};
    if (message.nominees?.length) {
      obj.nominees = message.nominees.map((e) => Nominee.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpsertNomineesRequest>, I>>(base?: I): UpsertNomineesRequest {
    return UpsertNomineesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpsertNomineesRequest>, I>>(object: I): UpsertNomineesRequest {
    const message = createBaseUpsertNomineesRequest();
    message.nominees = object.nominees?.map((e) => Nominee.fromPartial(e)) || [];
    return message;
  },
};

function createBaseNomineeChangeRequest(): NomineeChangeRequest {
  return { id: 0, status: 0, nominees: [], requestedAt: 0, rejectionReason: "" };
}

export const NomineeChangeRequest = {
  encode(message: NomineeChangeRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== 0) {
      writer.uint32(8).int64(message.id);
    }
    if (message.status !== 0) {
      writer.uint32(16).int32(message.status);
    }
    for (const v of message.nominees) {
      Nominee.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    if (message.requestedAt !== 0) {
      writer.uint32(32).int64(message.requestedAt);
    }
    if (message.rejectionReason !== "") {
      writer.uint32(42).string(message.rejectionReason);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): NomineeChangeRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNomineeChangeRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.nominees.push(Nominee.decode(reader, reader.uint32()));
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.requestedAt = longToNumber(reader.int64() as Long);
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.rejectionReason = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NomineeChangeRequest {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      status: isSet(object.status) ? nomineeChangeRequestStatusFromJSON(object.status) : 0,
      nominees: globalThis.Array.isArray(object?.nominees) ? object.nominees.map((e: any) => Nominee.fromJSON(e)) : [],
      requestedAt: isSet(object.requestedAt) ? globalThis.Number(object.requestedAt) : 0,
      rejectionReason: isSet(object.rejectionReason) ? globalThis.String(object.rejectionReason) : "",
    };
  },

  toJSON(message: NomineeChangeRequest): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.status !== 0) {
      obj.status = nomineeChangeRequestStatusToJSON(message.status);
    }
    if (message.nominees?.length) {
      obj.nominees = message.nominees.map((e) => Nominee.toJSON(e));
    }
    if (message.requestedAt !== 0) {
      obj.requestedAt = Math.round(message.requestedAt);
    }
    if (message.rejectionReason !== "") {
      obj.rejectionReason = message.rejectionReason;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NomineeChangeRequest>, I>>(base?: I): NomineeChangeRequest {
    return NomineeChangeRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NomineeChangeRequest>, I>>(object: I): NomineeChangeRequest {
    const message = createBaseNomineeChangeRequest();
    message.id = object.id ?? 0;
    message.status = object.status ?? 0;
    message.nominees = object.nominees?.map((e) => Nominee.fromPartial(e)) || [];
    message.requestedAt = object.requestedAt ?? 0;
    message.rejectionReason = object.rejectionReason ?? "";
    return message;
  },
};

function createBaseGetNomineeChangeRequestRequest(): GetNomineeChangeRequestRequest {
  return {};
}

export const GetNomineeChangeRequestRequest = {
  encode(_: GetNomineeChangeRequestRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetNomineeChangeRequestRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetNomineeChangeRequestRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetNomineeChangeRequestRequest {
    return {};
  },

  toJSON(_: GetNomineeChangeRequestRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetNomineeChangeRequestRequest>, I>>(base?: I): GetNomineeChangeRequestRequest {
    return GetNomineeChangeRequestRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetNomineeChangeRequestRequest>, I>>(_: I): GetNomineeChangeRequestRequest {
    const message = createBaseGetNomineeChangeRequestRequest();
    return message;
  },
};

function createBaseApproveNomineeChangeRequestRequest(): ApproveNomineeChangeRequestRequest {
  return { accountId: "" };
}

export const ApproveNomineeChangeRequestRequest = {
  encode(message: ApproveNomineeChangeRequestRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.accountId !== "") {
      writer.uint32(10).string(message.accountId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ApproveNomineeChangeRequestRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApproveNomineeChangeRequestRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.accountId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ApproveNomineeChangeRequestRequest {
    return { accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : "" };
  },

  toJSON(message: ApproveNomineeChangeRequestRequest): unknown {
    const obj: any = {};
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ApproveNomineeChangeRequestRequest>, I>>(
    base?: I,
  ): ApproveNomineeChangeRequestRequest {
    return ApproveNomineeChangeRequestRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ApproveNomineeChangeRequestRequest>, I>>(
    object: I,
  ): ApproveNomineeChangeRequestRequest {
    const message = createBaseApproveNomineeChangeRequestRequest();
    message.accountId = object.accountId ?? "";
    return message;
  },
};

function createBaseRejectNomineeChangeRequestRequest(): RejectNomineeChangeRequestRequest {
  return { accountId: "", reason: "" };
}

export const RejectNomineeChangeRequestRequest = {
  encode(message: RejectNomineeChangeRequestRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.accountId !== "") {
      writer.uint32(10).string(message.accountId);
    }
    if (message.reason !== "") {
      writer.uint32(18).string(message.reason);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RejectNomineeChangeRequestRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRejectNomineeChangeRequestRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.accountId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.reason = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RejectNomineeChangeRequestRequest {
    return {
      accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : "",
      reason: isSet(object.reason) ? globalThis.String(object.reason) : "",
    };
  },

  toJSON(message: RejectNomineeChangeRequestRequest): unknown {
    const obj: any = {};
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    if (message.reason !== "") {
      obj.reason = message.reason;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RejectNomineeChangeRequestRequest>, I>>(
    base?: I,
  ): RejectNomineeChangeRequestRequest {
    return RejectNomineeChangeRequestRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RejectNomineeChangeRequestRequest>, I>>(
    object: I,
  ): RejectNomineeChangeRequestRequest {
    const message = createBaseRejectNomineeChangeRequestRequest();
    message.accountId = object.accountId ?? "";
    message.reason = object.reason ?? "";
    return message;
  },
};

function createBaseDematAccountRequest(): DematAccountRequest {
  return { dematAccount: undefined };
}

export const DematAccountRequest = {
  encode(message: DematAccountRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.dematAccount !== undefined) {
      DematAccountDetail.encode(message.dematAccount, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DematAccountRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDematAccountRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.dematAccount = DematAccountDetail.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DematAccountRequest {
    return { dematAccount: isSet(object.dematAccount) ? DematAccountDetail.fromJSON(object.dematAccount) : undefined };
  },

  toJSON(message: DematAccountRequest): unknown {
    const obj: any = {};
    if (message.dematAccount !== undefined) {
      obj.dematAccount = DematAccountDetail.toJSON(message.dematAccount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DematAccountRequest>, I>>(base?: I): DematAccountRequest {
    return DematAccountRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DematAccountRequest>, I>>(object: I): DematAccountRequest {
    const message = createBaseDematAccountRequest();
    message.dematAccount = (object.dematAccount !== undefined && object.dematAccount !== null)
      ? DematAccountDetail.fromPartial(object.dematAccount)
      : undefined;
    return message;
  },
};

function createBaseRemoveDematAccountRequest(): RemoveDematAccountRequest {
  return { id: 0 };
}

export const RemoveDematAccountRequest = {
  encode(message: RemoveDematAccountRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== 0) {
      writer.uint32(8).int64(message.id);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RemoveDematAccountRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveDematAccountRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemoveDematAccountRequest {
    return { id: isSet(object.id) ? globalThis.Number(object.id) : 0 };
  },

  toJSON(message: RemoveDematAccountRequest): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RemoveDematAccountRequest>, I>>(base?: I): RemoveDematAccountRequest {
    return RemoveDematAccountRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoveDematAccountRequest>, I>>(object: I): RemoveDematAccountRequest {
    const message = createBaseRemoveDematAccountRequest();
    message.id = object.id ?? 0;
    return message;
  },
};

function createBaseCreateDocumentUploadUrlRequest(): CreateDocumentUploadUrlRequest {
  return { documentType: "", fileName: "", contentType: "" };
}

export const CreateDocumentUploadUrlRequest = {
  encode(message: CreateDocumentUploadUrlRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.documentType !== "") {
      writer.uint32(10).string(message.documentType);
    }
    if (message.fileName !== "") {
      writer.uint32(18).string(message.fileName);
    }
    if (message.contentType !== "") {
      writer.uint32(26).string(message.contentType);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CreateDocumentUploadUrlRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateDocumentUploadUrlRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.documentType = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.fileName = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.contentType = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateDocumentUploadUrlRequest {
    return {
      documentType: isSet(object.documentType) ? globalThis.String(object.documentType) : "",
      fileName: isSet(object.fileName) ? globalThis.String(object.fileName) : "",
      contentType: isSet(object.contentType) ? globalThis.String(object.contentType) : "",
    };
  },

  toJSON(message: CreateDocumentUploadUrlRequest): unknown {
    const obj: any = {};
    if (message.documentType !== "") {
      obj.documentType = message.documentType;
    }
    if (message.fileName !== "") {
      obj.fileName = message.fileName;
    }
    if (message.contentType !== "") {
      obj.contentType = message.contentType;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateDocumentUploadUrlRequest>, I>>(base?: I): CreateDocumentUploadUrlRequest {
    return CreateDocumentUploadUrlRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateDocumentUploadUrlRequest>, I>>(
    object: I,
  ): CreateDocumentUploadUrlRequest {
    const message = createBaseCreateDocumentUploadUrlRequest();
    message.documentType = object.documentType ?? "";
    message.fileName = object.fileName ?? "";
    message.contentType = object.contentType ?? "";
    return message;
  },
};

function createBaseCreateDocumentUploadUrlResponse(): CreateDocumentUploadUrlResponse {
  return { documentId: 0, uploadUrl: "", s3Key: "" };
}

export const CreateDocumentUploadUrlResponse = {
  encode(message: CreateDocumentUploadUrlResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.documentId !== 0) {
      writer.uint32(8).int64(message.documentId);
    }
    if (message.uploadUrl !== "") {
      writer.uint32(18).string(message.uploadUrl);
    }
    if (message.s3Key !== "") {
      writer.uint32(26).string(message.s3Key);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CreateDocumentUploadUrlResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateDocumentUploadUrlResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.documentId = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.uploadUrl = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.s3Key = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateDocumentUploadUrlResponse {
    return {
      documentId: isSet(object.documentId) ? globalThis.Number(object.documentId) : 0,
      uploadUrl: isSet(object.uploadUrl) ? globalThis.String(object.uploadUrl) : "",
      s3Key: isSet(object.s3Key) ? globalThis.String(object.s3Key) : "",
    };
  },

  toJSON(message: CreateDocumentUploadUrlResponse): unknown {
    const obj: any = {};
    if (message.documentId !== 0) {
      obj.documentId = Math.round(message.documentId);
    }
    if (message.uploadUrl !== "") {
      obj.uploadUrl = message.uploadUrl;
    }
    if (message.s3Key !== "") {
      obj.s3Key = message.s3Key;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateDocumentUploadUrlResponse>, I>>(base?: I): CreateDocumentUploadUrlResponse {
    return CreateDocumentUploadUrlResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateDocumentUploadUrlResponse>, I>>(
    object: I,
  ): CreateDocumentUploadUrlResponse {
    const message = createBaseCreateDocumentUploadUrlResponse();
    message.documentId = object.documentId ?? 0;
    message.uploadUrl = object.uploadUrl ?? "";
    message.s3Key = object.s3Key ?? "";
    return message;
  },
};

function createBaseSetKillSwitchRequest(): SetKillSwitchRequest {
  return { exchange: "", segment: "", duration: 0 };
}

export const SetKillSwitchRequest = {
  encode(message: SetKillSwitchRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.exchange !== "") {
      writer.uint32(10).string(message.exchange);
    }
    if (message.segment !== "") {
      writer.uint32(18).string(message.segment);
    }
    if (message.duration !== 0) {
      writer.uint32(24).int32(message.duration);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetKillSwitchRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetKillSwitchRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.exchange = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.segment = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.duration = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetKillSwitchRequest {
    return {
      exchange: isSet(object.exchange) ? globalThis.String(object.exchange) : "",
      segment: isSet(object.segment) ? globalThis.String(object.segment) : "",
      duration: isSet(object.duration) ? killSwitchDurationFromJSON(object.duration) : 0,
    };
  },

  toJSON(message: SetKillSwitchRequest): unknown {
    const obj: any = {};
    if (message.exchange !== "") {
      obj.exchange = message.exchange;
    }
    if (message.segment !== "") {
      obj.segment = message.segment;
    }
    if (message.duration !== 0) {
      obj.duration = killSwitchDurationToJSON(message.duration);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetKillSwitchRequest>, I>>(base?: I): SetKillSwitchRequest {
    return SetKillSwitchRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetKillSwitchRequest>, I>>(object: I): SetKillSwitchRequest {
    const message = createBaseSetKillSwitchRequest();
    message.exchange = object.exchange ?? "";
    message.segment = object.segment ?? "";
    message.duration = object.duration ?? 0;
    return message;
  },
};

function createBaseGetKillSwitchStatusRequest(): GetKillSwitchStatusRequest {
  return {};
}

export const GetKillSwitchStatusRequest = {
  encode(_: GetKillSwitchStatusRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetKillSwitchStatusRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetKillSwitchStatusRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetKillSwitchStatusRequest {
    return {};
  },

  toJSON(_: GetKillSwitchStatusRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetKillSwitchStatusRequest>, I>>(base?: I): GetKillSwitchStatusRequest {
    return GetKillSwitchStatusRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetKillSwitchStatusRequest>, I>>(_: I): GetKillSwitchStatusRequest {
    const message = createBaseGetKillSwitchStatusRequest();
    return message;
  },
};

function createBaseKillSwitchStatusResponse(): KillSwitchStatusResponse {
  return { segments: [] };
}

export const KillSwitchStatusResponse = {
  encode(message: KillSwitchStatusResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.segments) {
      SegmentActivation.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): KillSwitchStatusResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKillSwitchStatusResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.segments.push(SegmentActivation.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KillSwitchStatusResponse {
    return {
      segments: globalThis.Array.isArray(object?.segments)
        ? object.segments.map((e: any) => SegmentActivation.fromJSON(e))
        : [],
    };
  },

  toJSON(message: KillSwitchStatusResponse): unknown {
    const obj: any = {};
    if (message.segments?.length) {
      obj.segments = message.segments.map((e) => SegmentActivation.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<KillSwitchStatusResponse>, I>>(base?: I): KillSwitchStatusResponse {
    return KillSwitchStatusResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<KillSwitchStatusResponse>, I>>(object: I): KillSwitchStatusResponse {
    const message = createBaseKillSwitchStatusResponse();
    message.segments = object.segments?.map((e) => SegmentActivation.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSetSegmentActivationRequest(): SetSegmentActivationRequest {
  return { accountId: "", exchange: "", segment: "", activationStatus: 0 };
}

export const SetSegmentActivationRequest = {
  encode(message: SetSegmentActivationRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.accountId !== "") {
      writer.uint32(10).string(message.accountId);
    }
    if (message.exchange !== "") {
      writer.uint32(18).string(message.exchange);
    }
    if (message.segment !== "") {
      writer.uint32(26).string(message.segment);
    }
    if (message.activationStatus !== 0) {
      writer.uint32(32).int32(message.activationStatus);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetSegmentActivationRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetSegmentActivationRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.accountId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.exchange = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.segment = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.activationStatus = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetSegmentActivationRequest {
    return {
      accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : "",
      exchange: isSet(object.exchange) ? globalThis.String(object.exchange) : "",
      segment: isSet(object.segment) ? globalThis.String(object.segment) : "",
      activationStatus: isSet(object.activationStatus) ? segmentActivationStatusFromJSON(object.activationStatus) : 0,
    };
  },

  toJSON(message: SetSegmentActivationRequest): unknown {
    const obj: any = {};
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    if (message.exchange !== "") {
      obj.exchange = message.exchange;
    }
    if (message.segment !== "") {
      obj.segment = message.segment;
    }
    if (message.activationStatus !== 0) {
      obj.activationStatus = segmentActivationStatusToJSON(message.activationStatus);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetSegmentActivationRequest>, I>>(base?: I): SetSegmentActivationRequest {
    return SetSegmentActivationRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetSegmentActivationRequest>, I>>(object: I): SetSegmentActivationRequest {
    const message = createBaseSetSegmentActivationRequest();
    message.accountId = object.accountId ?? "";
    message.exchange = object.exchange ?? "";
    message.segment = object.segment ?? "";
    message.activationStatus = object.activationStatus ?? 0;
    return message;
  },
};

function createBaseVerifyBankAccountRequest(): VerifyBankAccountRequest {
  return { accountId: "", id: 0, verified: false };
}

export const VerifyBankAccountRequest = {
  encode(message: VerifyBankAccountRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.accountId !== "") {
      writer.uint32(10).string(message.accountId);
    }
    if (message.id !== 0) {
      writer.uint32(16).int64(message.id);
    }
    if (message.verified !== false) {
      writer.uint32(24).bool(message.verified);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): VerifyBankAccountRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVerifyBankAccountRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.accountId = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.id = longToNumber(reader.int64() as Long);
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.verified = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VerifyBankAccountRequest {
    return {
      accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : "",
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      verified: isSet(object.verified) ? globalThis.Boolean(object.verified) : false,
    };
  },

  toJSON(message: VerifyBankAccountRequest): unknown {
    const obj: any = {};
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.verified !== false) {
      obj.verified = message.verified;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VerifyBankAccountRequest>, I>>(base?: I): VerifyBankAccountRequest {
    return VerifyBankAccountRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VerifyBankAccountRequest>, I>>(object: I): VerifyBankAccountRequest {
    const message = createBaseVerifyBankAccountRequest();
    message.accountId = object.accountId ?? "";
    message.id = object.id ?? 0;
    message.verified = object.verified ?? false;
    return message;
  },
};

function createBaseVerifyDematAccountRequest(): VerifyDematAccountRequest {
  return { accountId: "", id: 0, verified: false };
}

export const VerifyDematAccountRequest = {
  encode(message: VerifyDematAccountRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.accountId !== "") {
      writer.uint32(10).string(message.accountId);
    }
    if (message.id !== 0) {
      writer.uint32(16).int64(message.id);
    }
    if (message.verified !== false) {
      writer.uint32(24).bool(message.verified);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): VerifyDematAccountRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVerifyDematAccountRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.accountId = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.id = longToNumber(reader.int64() as Long);
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.verified = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VerifyDematAccountRequest {
    return {
      accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : "",
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      verified: isSet(object.verified) ? globalThis.Boolean(object.verified) : false,
    };
  },

  toJSON(message: VerifyDematAccountRequest): unknown {
    const obj: any = {};
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.verified !== false) {
      obj.verified = message.verified;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VerifyDematAccountRequest>, I>>(base?: I): VerifyDematAccountRequest {
    return VerifyDematAccountRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VerifyDematAccountRequest>, I>>(object: I): VerifyDematAccountRequest {
    const message = createBaseVerifyDematAccountRequest();
    message.accountId = object.accountId ?? "";
    message.id = object.id ?? 0;
    message.verified = object.verified ?? false;
    return message;
  },
};

function createBaseVerifyDocumentRequest(): VerifyDocumentRequest {
  return { accountId: "", documentId: 0, status: "" };
}

export const VerifyDocumentRequest = {
  encode(message: VerifyDocumentRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.accountId !== "") {
      writer.uint32(10).string(message.accountId);
    }
    if (message.documentId !== 0) {
      writer.uint32(16).int64(message.documentId);
    }
    if (message.status !== "") {
      writer.uint32(26).string(message.status);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): VerifyDocumentRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVerifyDocumentRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.accountId = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.documentId = longToNumber(reader.int64() as Long);
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.status = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VerifyDocumentRequest {
    return {
      accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : "",
      documentId: isSet(object.documentId) ? globalThis.Number(object.documentId) : 0,
      status: isSet(object.status) ? globalThis.String(object.status) : "",
    };
  },

  toJSON(message: VerifyDocumentRequest): unknown {
    const obj: any = {};
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    if (message.documentId !== 0) {
      obj.documentId = Math.round(message.documentId);
    }
    if (message.status !== "") {
      obj.status = message.status;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VerifyDocumentRequest>, I>>(base?: I): VerifyDocumentRequest {
    return VerifyDocumentRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VerifyDocumentRequest>, I>>(object: I): VerifyDocumentRequest {
    const message = createBaseVerifyDocumentRequest();
    message.accountId = object.accountId ?? "";
    message.documentId = object.documentId ?? 0;
    message.status = object.status ?? "";
    return message;
  },
};

function createBaseTradingAccountDocument(): TradingAccountDocument {
  return {
    accountId: "",
    documentType: "",
    s3PresignedUrl: "",
    fileName: "",
    sizeBytes: 0,
    lastModified: 0,
    documentId: 0,
    formReference: "",
    source: "",
    status: "",
  };
}

export const TradingAccountDocument = {
  encode(message: TradingAccountDocument, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.accountId !== "") {
      writer.uint32(10).string(message.accountId);
    }
    if (message.documentType !== "") {
      writer.uint32(18).string(message.documentType);
    }
    if (message.s3PresignedUrl !== "") {
      writer.uint32(26).string(message.s3PresignedUrl);
    }
    if (message.fileName !== "") {
      writer.uint32(34).string(message.fileName);
    }
    if (message.sizeBytes !== 0) {
      writer.uint32(40).int64(message.sizeBytes);
    }
    if (message.lastModified !== 0) {
      writer.uint32(48).int64(message.lastModified);
    }
    if (message.documentId !== 0) {
      writer.uint32(56).int64(message.documentId);
    }
    if (message.formReference !== "") {
      writer.uint32(66).string(message.formReference);
    }
    if (message.source !== "") {
      writer.uint32(74).string(message.source);
    }
    if (message.status !== "") {
      writer.uint32(82).string(message.status);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TradingAccountDocument {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTradingAccountDocument();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.accountId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.documentType = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.s3PresignedUrl = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.fileName = reader.string();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.sizeBytes = longToNumber(reader.int64() as Long);
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.lastModified = longToNumber(reader.int64() as Long);
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.documentId = longToNumber(reader.int64() as Long);
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.formReference = reader.string();
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.source = reader.string();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.status = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TradingAccountDocument {
    return {
      accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : "",
      documentType: isSet(object.documentType) ? globalThis.String(object.documentType) : "",
      s3PresignedUrl: isSet(object.s3PresignedUrl) ? globalThis.String(object.s3PresignedUrl) : "",
      fileName: isSet(object.fileName) ? globalThis.String(object.fileName) : "",
      sizeBytes: isSet(object.sizeBytes) ? globalThis.Number(object.sizeBytes) : 0,
      lastModified: isSet(object.lastModified) ? globalThis.Number(object.lastModified) : 0,
      documentId: isSet(object.documentId) ? globalThis.Number(object.documentId) : 0,
      formReference: isSet(object.formReference) ? globalThis.String(object.formReference) : "",
      source: isSet(object.source) ? globalThis.String(object.source) : "",
      status: isSet(object.status) ? globalThis.String(object.status) : "",
    };
  },

  toJSON(message: TradingAccountDocument): unknown {
    const obj: any = {};
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    if (message.documentType !== "") {
      obj.documentType = message.documentType;
    }
    if (message.s3PresignedUrl !== "") {
      obj.s3PresignedUrl = message.s3PresignedUrl;
    }
    if (message.fileName !== "") {
      obj.fileName = message.fileName;
    }
    if (message.sizeBytes !== 0) {
      obj.sizeBytes = Math.round(message.sizeBytes);
    }
    if (message.lastModified !== 0) {
      obj.lastModified = Math.round(message.lastModified);
    }
    if (message.documentId !== 0) {
      obj.documentId = Math.round(message.documentId);
    }
    if (message.formReference !== "") {
      obj.formReference = message.formReference;
    }
    if (message.source !== "") {
      obj.source = message.source;
    }
    if (message.status !== "") {
      obj.status = message.status;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TradingAccountDocument>, I>>(base?: I): TradingAccountDocument {
    return TradingAccountDocument.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TradingAccountDocument>, I>>(object: I): TradingAccountDocument {
    const message = createBaseTradingAccountDocument();
    message.accountId = object.accountId ?? "";
    message.documentType = object.documentType ?? "";
    message.s3PresignedUrl = object.s3PresignedUrl ?? "";
    message.fileName = object.fileName ?? "";
    message.sizeBytes = object.sizeBytes ?? 0;
    message.lastModified = object.lastModified ?? 0;
    message.documentId = object.documentId ?? 0;
    message.formReference = object.formReference ?? "";
    message.source = object.source ?? "";
    message.status = object.status ?? "";
    return message;
  },
};

function createBaseInitiateDematApplicationRequest(): InitiateDematApplicationRequest {
  return { name: "", email: "", mobile: "" };
}

export const InitiateDematApplicationRequest = {
  encode(message: InitiateDematApplicationRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.email !== "") {
      writer.uint32(18).string(message.email);
    }
    if (message.mobile !== "") {
      writer.uint32(26).string(message.mobile);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): InitiateDematApplicationRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInitiateDematApplicationRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.email = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.mobile = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InitiateDematApplicationRequest {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      mobile: isSet(object.mobile) ? globalThis.String(object.mobile) : "",
    };
  },

  toJSON(message: InitiateDematApplicationRequest): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.mobile !== "") {
      obj.mobile = message.mobile;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InitiateDematApplicationRequest>, I>>(base?: I): InitiateDematApplicationRequest {
    return InitiateDematApplicationRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InitiateDematApplicationRequest>, I>>(
    object: I,
  ): InitiateDematApplicationRequest {
    const message = createBaseInitiateDematApplicationRequest();
    message.name = object.name ?? "";
    message.email = object.email ?? "";
    message.mobile = object.mobile ?? "";
    return message;
  },
};

function createBaseInitiateDematApplicationResponse(): InitiateDematApplicationResponse {
  return { accountId: "", redirectUrl: "", webCallbackUrl: "" };
}

export const InitiateDematApplicationResponse = {
  encode(message: InitiateDematApplicationResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.accountId !== "") {
      writer.uint32(10).string(message.accountId);
    }
    if (message.redirectUrl !== "") {
      writer.uint32(18).string(message.redirectUrl);
    }
    if (message.webCallbackUrl !== "") {
      writer.uint32(26).string(message.webCallbackUrl);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): InitiateDematApplicationResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInitiateDematApplicationResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.accountId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.redirectUrl = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.webCallbackUrl = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InitiateDematApplicationResponse {
    return {
      accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : "",
      redirectUrl: isSet(object.redirectUrl) ? globalThis.String(object.redirectUrl) : "",
      webCallbackUrl: isSet(object.webCallbackUrl) ? globalThis.String(object.webCallbackUrl) : "",
    };
  },

  toJSON(message: InitiateDematApplicationResponse): unknown {
    const obj: any = {};
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    if (message.redirectUrl !== "") {
      obj.redirectUrl = message.redirectUrl;
    }
    if (message.webCallbackUrl !== "") {
      obj.webCallbackUrl = message.webCallbackUrl;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InitiateDematApplicationResponse>, I>>(
    base?: I,
  ): InitiateDematApplicationResponse {
    return InitiateDematApplicationResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InitiateDematApplicationResponse>, I>>(
    object: I,
  ): InitiateDematApplicationResponse {
    const message = createBaseInitiateDematApplicationResponse();
    message.accountId = object.accountId ?? "";
    message.redirectUrl = object.redirectUrl ?? "";
    message.webCallbackUrl = object.webCallbackUrl ?? "";
    return message;
  },
};

function createBaseGetDematApplicationStatusRequest(): GetDematApplicationStatusRequest {
  return {};
}

export const GetDematApplicationStatusRequest = {
  encode(_: GetDematApplicationStatusRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetDematApplicationStatusRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDematApplicationStatusRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetDematApplicationStatusRequest {
    return {};
  },

  toJSON(_: GetDematApplicationStatusRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetDematApplicationStatusRequest>, I>>(
    base?: I,
  ): GetDematApplicationStatusRequest {
    return GetDematApplicationStatusRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetDematApplicationStatusRequest>, I>>(
    _: I,
  ): GetDematApplicationStatusRequest {
    const message = createBaseGetDematApplicationStatusRequest();
    return message;
  },
};

function createBaseGetDematApplicationStatusResponse(): GetDematApplicationStatusResponse {
  return { account: undefined };
}

export const GetDematApplicationStatusResponse = {
  encode(message: GetDematApplicationStatusResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.account !== undefined) {
      TradingAccount.encode(message.account, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetDematApplicationStatusResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDematApplicationStatusResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.account = TradingAccount.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDematApplicationStatusResponse {
    return { account: isSet(object.account) ? TradingAccount.fromJSON(object.account) : undefined };
  },

  toJSON(message: GetDematApplicationStatusResponse): unknown {
    const obj: any = {};
    if (message.account !== undefined) {
      obj.account = TradingAccount.toJSON(message.account);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetDematApplicationStatusResponse>, I>>(
    base?: I,
  ): GetDematApplicationStatusResponse {
    return GetDematApplicationStatusResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetDematApplicationStatusResponse>, I>>(
    object: I,
  ): GetDematApplicationStatusResponse {
    const message = createBaseGetDematApplicationStatusResponse();
    message.account = (object.account !== undefined && object.account !== null)
      ? TradingAccount.fromPartial(object.account)
      : undefined;
    return message;
  },
};

function createBaseGetDematApplicationsAdminRequest(): GetDematApplicationsAdminRequest {
  return { statusFilter: 0, page: 0, pageSize: 0 };
}

export const GetDematApplicationsAdminRequest = {
  encode(message: GetDematApplicationsAdminRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.statusFilter !== 0) {
      writer.uint32(8).int32(message.statusFilter);
    }
    if (message.page !== 0) {
      writer.uint32(16).int32(message.page);
    }
    if (message.pageSize !== 0) {
      writer.uint32(24).int32(message.pageSize);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetDematApplicationsAdminRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDematApplicationsAdminRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.statusFilter = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.page = reader.int32();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.pageSize = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDematApplicationsAdminRequest {
    return {
      statusFilter: isSet(object.statusFilter) ? tradingAccountStatusFromJSON(object.statusFilter) : 0,
      page: isSet(object.page) ? globalThis.Number(object.page) : 0,
      pageSize: isSet(object.pageSize) ? globalThis.Number(object.pageSize) : 0,
    };
  },

  toJSON(message: GetDematApplicationsAdminRequest): unknown {
    const obj: any = {};
    if (message.statusFilter !== 0) {
      obj.statusFilter = tradingAccountStatusToJSON(message.statusFilter);
    }
    if (message.page !== 0) {
      obj.page = Math.round(message.page);
    }
    if (message.pageSize !== 0) {
      obj.pageSize = Math.round(message.pageSize);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetDematApplicationsAdminRequest>, I>>(
    base?: I,
  ): GetDematApplicationsAdminRequest {
    return GetDematApplicationsAdminRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetDematApplicationsAdminRequest>, I>>(
    object: I,
  ): GetDematApplicationsAdminRequest {
    const message = createBaseGetDematApplicationsAdminRequest();
    message.statusFilter = object.statusFilter ?? 0;
    message.page = object.page ?? 0;
    message.pageSize = object.pageSize ?? 0;
    return message;
  },
};

function createBaseGetDematApplicationsAdminResponse(): GetDematApplicationsAdminResponse {
  return { accounts: [], total: 0 };
}

export const GetDematApplicationsAdminResponse = {
  encode(message: GetDematApplicationsAdminResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.accounts) {
      TradingAccount.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    if (message.total !== 0) {
      writer.uint32(16).int32(message.total);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetDematApplicationsAdminResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDematApplicationsAdminResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.accounts.push(TradingAccount.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.total = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDematApplicationsAdminResponse {
    return {
      accounts: globalThis.Array.isArray(object?.accounts)
        ? object.accounts.map((e: any) => TradingAccount.fromJSON(e))
        : [],
      total: isSet(object.total) ? globalThis.Number(object.total) : 0,
    };
  },

  toJSON(message: GetDematApplicationsAdminResponse): unknown {
    const obj: any = {};
    if (message.accounts?.length) {
      obj.accounts = message.accounts.map((e) => TradingAccount.toJSON(e));
    }
    if (message.total !== 0) {
      obj.total = Math.round(message.total);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetDematApplicationsAdminResponse>, I>>(
    base?: I,
  ): GetDematApplicationsAdminResponse {
    return GetDematApplicationsAdminResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetDematApplicationsAdminResponse>, I>>(
    object: I,
  ): GetDematApplicationsAdminResponse {
    const message = createBaseGetDematApplicationsAdminResponse();
    message.accounts = object.accounts?.map((e) => TradingAccount.fromPartial(e)) || [];
    message.total = object.total ?? 0;
    return message;
  },
};

function createBaseGetDematApplicationAdminRequest(): GetDematApplicationAdminRequest {
  return { accountId: "" };
}

export const GetDematApplicationAdminRequest = {
  encode(message: GetDematApplicationAdminRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.accountId !== "") {
      writer.uint32(10).string(message.accountId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetDematApplicationAdminRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDematApplicationAdminRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.accountId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDematApplicationAdminRequest {
    return { accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : "" };
  },

  toJSON(message: GetDematApplicationAdminRequest): unknown {
    const obj: any = {};
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetDematApplicationAdminRequest>, I>>(base?: I): GetDematApplicationAdminRequest {
    return GetDematApplicationAdminRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetDematApplicationAdminRequest>, I>>(
    object: I,
  ): GetDematApplicationAdminRequest {
    const message = createBaseGetDematApplicationAdminRequest();
    message.accountId = object.accountId ?? "";
    return message;
  },
};

function createBaseActivateTradingAccountRequest(): ActivateTradingAccountRequest {
  return {
    accountId: "",
    clientCode: "",
    proClientIndicator: "",
    segmentsToActivate: [],
    pan: "",
    holderName: "",
    dob: "",
    address: "",
  };
}

export const ActivateTradingAccountRequest = {
  encode(message: ActivateTradingAccountRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.accountId !== "") {
      writer.uint32(10).string(message.accountId);
    }
    if (message.clientCode !== "") {
      writer.uint32(18).string(message.clientCode);
    }
    if (message.proClientIndicator !== "") {
      writer.uint32(34).string(message.proClientIndicator);
    }
    for (const v of message.segmentsToActivate) {
      SegmentActivationSpec.encode(v!, writer.uint32(42).fork()).ldelim();
    }
    if (message.pan !== "") {
      writer.uint32(50).string(message.pan);
    }
    if (message.holderName !== "") {
      writer.uint32(58).string(message.holderName);
    }
    if (message.dob !== "") {
      writer.uint32(66).string(message.dob);
    }
    if (message.address !== "") {
      writer.uint32(74).string(message.address);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ActivateTradingAccountRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseActivateTradingAccountRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.accountId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.clientCode = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.proClientIndicator = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.segmentsToActivate.push(SegmentActivationSpec.decode(reader, reader.uint32()));
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.pan = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.holderName = reader.string();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.dob = reader.string();
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.address = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ActivateTradingAccountRequest {
    return {
      accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : "",
      clientCode: isSet(object.clientCode) ? globalThis.String(object.clientCode) : "",
      proClientIndicator: isSet(object.proClientIndicator) ? globalThis.String(object.proClientIndicator) : "",
      segmentsToActivate: globalThis.Array.isArray(object?.segmentsToActivate)
        ? object.segmentsToActivate.map((e: any) => SegmentActivationSpec.fromJSON(e))
        : [],
      pan: isSet(object.pan) ? globalThis.String(object.pan) : "",
      holderName: isSet(object.holderName) ? globalThis.String(object.holderName) : "",
      dob: isSet(object.dob) ? globalThis.String(object.dob) : "",
      address: isSet(object.address) ? globalThis.String(object.address) : "",
    };
  },

  toJSON(message: ActivateTradingAccountRequest): unknown {
    const obj: any = {};
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    if (message.clientCode !== "") {
      obj.clientCode = message.clientCode;
    }
    if (message.proClientIndicator !== "") {
      obj.proClientIndicator = message.proClientIndicator;
    }
    if (message.segmentsToActivate?.length) {
      obj.segmentsToActivate = message.segmentsToActivate.map((e) => SegmentActivationSpec.toJSON(e));
    }
    if (message.pan !== "") {
      obj.pan = message.pan;
    }
    if (message.holderName !== "") {
      obj.holderName = message.holderName;
    }
    if (message.dob !== "") {
      obj.dob = message.dob;
    }
    if (message.address !== "") {
      obj.address = message.address;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ActivateTradingAccountRequest>, I>>(base?: I): ActivateTradingAccountRequest {
    return ActivateTradingAccountRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ActivateTradingAccountRequest>, I>>(
    object: I,
  ): ActivateTradingAccountRequest {
    const message = createBaseActivateTradingAccountRequest();
    message.accountId = object.accountId ?? "";
    message.clientCode = object.clientCode ?? "";
    message.proClientIndicator = object.proClientIndicator ?? "";
    message.segmentsToActivate = object.segmentsToActivate?.map((e) => SegmentActivationSpec.fromPartial(e)) || [];
    message.pan = object.pan ?? "";
    message.holderName = object.holderName ?? "";
    message.dob = object.dob ?? "";
    message.address = object.address ?? "";
    return message;
  },
};

function createBaseSegmentActivationSpec(): SegmentActivationSpec {
  return { exchange: "", segment: "" };
}

export const SegmentActivationSpec = {
  encode(message: SegmentActivationSpec, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.exchange !== "") {
      writer.uint32(10).string(message.exchange);
    }
    if (message.segment !== "") {
      writer.uint32(18).string(message.segment);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SegmentActivationSpec {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSegmentActivationSpec();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.exchange = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.segment = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SegmentActivationSpec {
    return {
      exchange: isSet(object.exchange) ? globalThis.String(object.exchange) : "",
      segment: isSet(object.segment) ? globalThis.String(object.segment) : "",
    };
  },

  toJSON(message: SegmentActivationSpec): unknown {
    const obj: any = {};
    if (message.exchange !== "") {
      obj.exchange = message.exchange;
    }
    if (message.segment !== "") {
      obj.segment = message.segment;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SegmentActivationSpec>, I>>(base?: I): SegmentActivationSpec {
    return SegmentActivationSpec.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SegmentActivationSpec>, I>>(object: I): SegmentActivationSpec {
    const message = createBaseSegmentActivationSpec();
    message.exchange = object.exchange ?? "";
    message.segment = object.segment ?? "";
    return message;
  },
};

function createBaseRejectDematApplicationRequest(): RejectDematApplicationRequest {
  return { accountId: "", reason: "" };
}

export const RejectDematApplicationRequest = {
  encode(message: RejectDematApplicationRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.accountId !== "") {
      writer.uint32(10).string(message.accountId);
    }
    if (message.reason !== "") {
      writer.uint32(18).string(message.reason);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RejectDematApplicationRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRejectDematApplicationRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.accountId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.reason = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RejectDematApplicationRequest {
    return {
      accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : "",
      reason: isSet(object.reason) ? globalThis.String(object.reason) : "",
    };
  },

  toJSON(message: RejectDematApplicationRequest): unknown {
    const obj: any = {};
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    if (message.reason !== "") {
      obj.reason = message.reason;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RejectDematApplicationRequest>, I>>(base?: I): RejectDematApplicationRequest {
    return RejectDematApplicationRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RejectDematApplicationRequest>, I>>(
    object: I,
  ): RejectDematApplicationRequest {
    const message = createBaseRejectDematApplicationRequest();
    message.accountId = object.accountId ?? "";
    message.reason = object.reason ?? "";
    return message;
  },
};

function createBaseHandleDigioWebhookRequest(): HandleDigioWebhookRequest {
  return { rawPayload: "", digioSignature: "" };
}

export const HandleDigioWebhookRequest = {
  encode(message: HandleDigioWebhookRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.rawPayload !== "") {
      writer.uint32(10).string(message.rawPayload);
    }
    if (message.digioSignature !== "") {
      writer.uint32(18).string(message.digioSignature);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): HandleDigioWebhookRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHandleDigioWebhookRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.rawPayload = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.digioSignature = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HandleDigioWebhookRequest {
    return {
      rawPayload: isSet(object.rawPayload) ? globalThis.String(object.rawPayload) : "",
      digioSignature: isSet(object.digioSignature) ? globalThis.String(object.digioSignature) : "",
    };
  },

  toJSON(message: HandleDigioWebhookRequest): unknown {
    const obj: any = {};
    if (message.rawPayload !== "") {
      obj.rawPayload = message.rawPayload;
    }
    if (message.digioSignature !== "") {
      obj.digioSignature = message.digioSignature;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HandleDigioWebhookRequest>, I>>(base?: I): HandleDigioWebhookRequest {
    return HandleDigioWebhookRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HandleDigioWebhookRequest>, I>>(object: I): HandleDigioWebhookRequest {
    const message = createBaseHandleDigioWebhookRequest();
    message.rawPayload = object.rawPayload ?? "";
    message.digioSignature = object.digioSignature ?? "";
    return message;
  },
};

function createBaseHandleDigioWebhookResponse(): HandleDigioWebhookResponse {
  return { processed: false };
}

export const HandleDigioWebhookResponse = {
  encode(message: HandleDigioWebhookResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.processed !== false) {
      writer.uint32(8).bool(message.processed);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): HandleDigioWebhookResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHandleDigioWebhookResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.processed = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HandleDigioWebhookResponse {
    return { processed: isSet(object.processed) ? globalThis.Boolean(object.processed) : false };
  },

  toJSON(message: HandleDigioWebhookResponse): unknown {
    const obj: any = {};
    if (message.processed !== false) {
      obj.processed = message.processed;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HandleDigioWebhookResponse>, I>>(base?: I): HandleDigioWebhookResponse {
    return HandleDigioWebhookResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HandleDigioWebhookResponse>, I>>(object: I): HandleDigioWebhookResponse {
    const message = createBaseHandleDigioWebhookResponse();
    message.processed = object.processed ?? false;
    return message;
  },
};

function createBaseGetUsersForTradingAccountRequest(): GetUsersForTradingAccountRequest {
  return { tradingAccountId: "" };
}

export const GetUsersForTradingAccountRequest = {
  encode(message: GetUsersForTradingAccountRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.tradingAccountId !== "") {
      writer.uint32(10).string(message.tradingAccountId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetUsersForTradingAccountRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetUsersForTradingAccountRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tradingAccountId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetUsersForTradingAccountRequest {
    return { tradingAccountId: isSet(object.tradingAccountId) ? globalThis.String(object.tradingAccountId) : "" };
  },

  toJSON(message: GetUsersForTradingAccountRequest): unknown {
    const obj: any = {};
    if (message.tradingAccountId !== "") {
      obj.tradingAccountId = message.tradingAccountId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetUsersForTradingAccountRequest>, I>>(
    base?: I,
  ): GetUsersForTradingAccountRequest {
    return GetUsersForTradingAccountRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetUsersForTradingAccountRequest>, I>>(
    object: I,
  ): GetUsersForTradingAccountRequest {
    const message = createBaseGetUsersForTradingAccountRequest();
    message.tradingAccountId = object.tradingAccountId ?? "";
    return message;
  },
};

function createBaseSetDebugForTradingAccountRequest(): SetDebugForTradingAccountRequest {
  return { tradingAccountId: "", debugMode: false };
}

export const SetDebugForTradingAccountRequest = {
  encode(message: SetDebugForTradingAccountRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.tradingAccountId !== "") {
      writer.uint32(10).string(message.tradingAccountId);
    }
    if (message.debugMode !== false) {
      writer.uint32(16).bool(message.debugMode);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetDebugForTradingAccountRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetDebugForTradingAccountRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tradingAccountId = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.debugMode = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetDebugForTradingAccountRequest {
    return {
      tradingAccountId: isSet(object.tradingAccountId) ? globalThis.String(object.tradingAccountId) : "",
      debugMode: isSet(object.debugMode) ? globalThis.Boolean(object.debugMode) : false,
    };
  },

  toJSON(message: SetDebugForTradingAccountRequest): unknown {
    const obj: any = {};
    if (message.tradingAccountId !== "") {
      obj.tradingAccountId = message.tradingAccountId;
    }
    if (message.debugMode !== false) {
      obj.debugMode = message.debugMode;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetDebugForTradingAccountRequest>, I>>(
    base?: I,
  ): SetDebugForTradingAccountRequest {
    return SetDebugForTradingAccountRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetDebugForTradingAccountRequest>, I>>(
    object: I,
  ): SetDebugForTradingAccountRequest {
    const message = createBaseSetDebugForTradingAccountRequest();
    message.tradingAccountId = object.tradingAccountId ?? "";
    message.debugMode = object.debugMode ?? false;
    return message;
  },
};

function createBaseGetUsersForTradingAccountResponse(): GetUsersForTradingAccountResponse {
  return { userIds: [] };
}

export const GetUsersForTradingAccountResponse = {
  encode(message: GetUsersForTradingAccountResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.userIds) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetUsersForTradingAccountResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetUsersForTradingAccountResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.userIds.push(reader.string());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetUsersForTradingAccountResponse {
    return {
      userIds: globalThis.Array.isArray(object?.userIds) ? object.userIds.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: GetUsersForTradingAccountResponse): unknown {
    const obj: any = {};
    if (message.userIds?.length) {
      obj.userIds = message.userIds;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetUsersForTradingAccountResponse>, I>>(
    base?: I,
  ): GetUsersForTradingAccountResponse {
    return GetUsersForTradingAccountResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetUsersForTradingAccountResponse>, I>>(
    object: I,
  ): GetUsersForTradingAccountResponse {
    const message = createBaseGetUsersForTradingAccountResponse();
    message.userIds = object.userIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetTradingAccountMarginRequest(): GetTradingAccountMarginRequest {
  return { accountId: "" };
}

export const GetTradingAccountMarginRequest = {
  encode(message: GetTradingAccountMarginRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.accountId !== "") {
      writer.uint32(18).string(message.accountId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetTradingAccountMarginRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTradingAccountMarginRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.accountId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetTradingAccountMarginRequest {
    return { accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : "" };
  },

  toJSON(message: GetTradingAccountMarginRequest): unknown {
    const obj: any = {};
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetTradingAccountMarginRequest>, I>>(base?: I): GetTradingAccountMarginRequest {
    return GetTradingAccountMarginRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetTradingAccountMarginRequest>, I>>(
    object: I,
  ): GetTradingAccountMarginRequest {
    const message = createBaseGetTradingAccountMarginRequest();
    message.accountId = object.accountId ?? "";
    return message;
  },
};

function createBaseTradingAccountMargins(): TradingAccountMargins {
  return { tradingAccountMargins: [] };
}

export const TradingAccountMargins = {
  encode(message: TradingAccountMargins, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.tradingAccountMargins) {
      TradingAccountMargin.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TradingAccountMargins {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTradingAccountMargins();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tradingAccountMargins.push(TradingAccountMargin.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TradingAccountMargins {
    return {
      tradingAccountMargins: globalThis.Array.isArray(object?.tradingAccountMargins)
        ? object.tradingAccountMargins.map((e: any) => TradingAccountMargin.fromJSON(e))
        : [],
    };
  },

  toJSON(message: TradingAccountMargins): unknown {
    const obj: any = {};
    if (message.tradingAccountMargins?.length) {
      obj.tradingAccountMargins = message.tradingAccountMargins.map((e) => TradingAccountMargin.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TradingAccountMargins>, I>>(base?: I): TradingAccountMargins {
    return TradingAccountMargins.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TradingAccountMargins>, I>>(object: I): TradingAccountMargins {
    const message = createBaseTradingAccountMargins();
    message.tradingAccountMargins = object.tradingAccountMargins?.map((e) => TradingAccountMargin.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTradingAccountMargin(): TradingAccountMargin {
  return {
    accountId: "",
    marginAvailable: 0,
    marginUsed: 0,
    cashAvailable: 0,
    collateralCash: 0,
    collateralNonCash: 0,
    openingBalance: 0,
    payIn: 0,
    payOut: 0,
    spanMargin: 0,
    exposureMargin: 0,
    optionsPremium: 0,
    computedMarginAvailable: 0,
  };
}

export const TradingAccountMargin = {
  encode(message: TradingAccountMargin, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.accountId !== "") {
      writer.uint32(18).string(message.accountId);
    }
    if (message.marginAvailable !== 0) {
      writer.uint32(33).double(message.marginAvailable);
    }
    if (message.marginUsed !== 0) {
      writer.uint32(49).double(message.marginUsed);
    }
    if (message.cashAvailable !== 0) {
      writer.uint32(65).double(message.cashAvailable);
    }
    if (message.collateralCash !== 0) {
      writer.uint32(81).double(message.collateralCash);
    }
    if (message.collateralNonCash !== 0) {
      writer.uint32(97).double(message.collateralNonCash);
    }
    if (message.openingBalance !== 0) {
      writer.uint32(113).double(message.openingBalance);
    }
    if (message.payIn !== 0) {
      writer.uint32(129).double(message.payIn);
    }
    if (message.payOut !== 0) {
      writer.uint32(145).double(message.payOut);
    }
    if (message.spanMargin !== 0) {
      writer.uint32(161).double(message.spanMargin);
    }
    if (message.exposureMargin !== 0) {
      writer.uint32(177).double(message.exposureMargin);
    }
    if (message.optionsPremium !== 0) {
      writer.uint32(193).double(message.optionsPremium);
    }
    if (message.computedMarginAvailable !== 0) {
      writer.uint32(209).double(message.computedMarginAvailable);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TradingAccountMargin {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTradingAccountMargin();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.accountId = reader.string();
          continue;
        case 4:
          if (tag !== 33) {
            break;
          }

          message.marginAvailable = reader.double();
          continue;
        case 6:
          if (tag !== 49) {
            break;
          }

          message.marginUsed = reader.double();
          continue;
        case 8:
          if (tag !== 65) {
            break;
          }

          message.cashAvailable = reader.double();
          continue;
        case 10:
          if (tag !== 81) {
            break;
          }

          message.collateralCash = reader.double();
          continue;
        case 12:
          if (tag !== 97) {
            break;
          }

          message.collateralNonCash = reader.double();
          continue;
        case 14:
          if (tag !== 113) {
            break;
          }

          message.openingBalance = reader.double();
          continue;
        case 16:
          if (tag !== 129) {
            break;
          }

          message.payIn = reader.double();
          continue;
        case 18:
          if (tag !== 145) {
            break;
          }

          message.payOut = reader.double();
          continue;
        case 20:
          if (tag !== 161) {
            break;
          }

          message.spanMargin = reader.double();
          continue;
        case 22:
          if (tag !== 177) {
            break;
          }

          message.exposureMargin = reader.double();
          continue;
        case 24:
          if (tag !== 193) {
            break;
          }

          message.optionsPremium = reader.double();
          continue;
        case 26:
          if (tag !== 209) {
            break;
          }

          message.computedMarginAvailable = reader.double();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TradingAccountMargin {
    return {
      accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : "",
      marginAvailable: isSet(object.marginAvailable) ? globalThis.Number(object.marginAvailable) : 0,
      marginUsed: isSet(object.marginUsed) ? globalThis.Number(object.marginUsed) : 0,
      cashAvailable: isSet(object.cashAvailable) ? globalThis.Number(object.cashAvailable) : 0,
      collateralCash: isSet(object.collateralCash) ? globalThis.Number(object.collateralCash) : 0,
      collateralNonCash: isSet(object.collateralNonCash) ? globalThis.Number(object.collateralNonCash) : 0,
      openingBalance: isSet(object.openingBalance) ? globalThis.Number(object.openingBalance) : 0,
      payIn: isSet(object.payIn) ? globalThis.Number(object.payIn) : 0,
      payOut: isSet(object.payOut) ? globalThis.Number(object.payOut) : 0,
      spanMargin: isSet(object.spanMargin) ? globalThis.Number(object.spanMargin) : 0,
      exposureMargin: isSet(object.exposureMargin) ? globalThis.Number(object.exposureMargin) : 0,
      optionsPremium: isSet(object.optionsPremium) ? globalThis.Number(object.optionsPremium) : 0,
      computedMarginAvailable: isSet(object.computedMarginAvailable)
        ? globalThis.Number(object.computedMarginAvailable)
        : 0,
    };
  },

  toJSON(message: TradingAccountMargin): unknown {
    const obj: any = {};
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    if (message.marginAvailable !== 0) {
      obj.marginAvailable = message.marginAvailable;
    }
    if (message.marginUsed !== 0) {
      obj.marginUsed = message.marginUsed;
    }
    if (message.cashAvailable !== 0) {
      obj.cashAvailable = message.cashAvailable;
    }
    if (message.collateralCash !== 0) {
      obj.collateralCash = message.collateralCash;
    }
    if (message.collateralNonCash !== 0) {
      obj.collateralNonCash = message.collateralNonCash;
    }
    if (message.openingBalance !== 0) {
      obj.openingBalance = message.openingBalance;
    }
    if (message.payIn !== 0) {
      obj.payIn = message.payIn;
    }
    if (message.payOut !== 0) {
      obj.payOut = message.payOut;
    }
    if (message.spanMargin !== 0) {
      obj.spanMargin = message.spanMargin;
    }
    if (message.exposureMargin !== 0) {
      obj.exposureMargin = message.exposureMargin;
    }
    if (message.optionsPremium !== 0) {
      obj.optionsPremium = message.optionsPremium;
    }
    if (message.computedMarginAvailable !== 0) {
      obj.computedMarginAvailable = message.computedMarginAvailable;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TradingAccountMargin>, I>>(base?: I): TradingAccountMargin {
    return TradingAccountMargin.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TradingAccountMargin>, I>>(object: I): TradingAccountMargin {
    const message = createBaseTradingAccountMargin();
    message.accountId = object.accountId ?? "";
    message.marginAvailable = object.marginAvailable ?? 0;
    message.marginUsed = object.marginUsed ?? 0;
    message.cashAvailable = object.cashAvailable ?? 0;
    message.collateralCash = object.collateralCash ?? 0;
    message.collateralNonCash = object.collateralNonCash ?? 0;
    message.openingBalance = object.openingBalance ?? 0;
    message.payIn = object.payIn ?? 0;
    message.payOut = object.payOut ?? 0;
    message.spanMargin = object.spanMargin ?? 0;
    message.exposureMargin = object.exposureMargin ?? 0;
    message.optionsPremium = object.optionsPremium ?? 0;
    message.computedMarginAvailable = object.computedMarginAvailable ?? 0;
    return message;
  },
};

function createBaseUpdateTradingAccountLimitsRequest(): UpdateTradingAccountLimitsRequest {
  return {
    accountId: "",
    collateralCash: undefined,
    collateralNonCash: undefined,
    openingBalance: undefined,
    payIn: undefined,
    payOut: undefined,
    payInDelta: undefined,
    payOutDelta: undefined,
  };
}

export const UpdateTradingAccountLimitsRequest = {
  encode(message: UpdateTradingAccountLimitsRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.accountId !== "") {
      writer.uint32(10).string(message.accountId);
    }
    if (message.collateralCash !== undefined) {
      writer.uint32(17).double(message.collateralCash);
    }
    if (message.collateralNonCash !== undefined) {
      writer.uint32(25).double(message.collateralNonCash);
    }
    if (message.openingBalance !== undefined) {
      writer.uint32(33).double(message.openingBalance);
    }
    if (message.payIn !== undefined) {
      writer.uint32(41).double(message.payIn);
    }
    if (message.payOut !== undefined) {
      writer.uint32(49).double(message.payOut);
    }
    if (message.payInDelta !== undefined) {
      writer.uint32(57).double(message.payInDelta);
    }
    if (message.payOutDelta !== undefined) {
      writer.uint32(65).double(message.payOutDelta);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UpdateTradingAccountLimitsRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateTradingAccountLimitsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.accountId = reader.string();
          continue;
        case 2:
          if (tag !== 17) {
            break;
          }

          message.collateralCash = reader.double();
          continue;
        case 3:
          if (tag !== 25) {
            break;
          }

          message.collateralNonCash = reader.double();
          continue;
        case 4:
          if (tag !== 33) {
            break;
          }

          message.openingBalance = reader.double();
          continue;
        case 5:
          if (tag !== 41) {
            break;
          }

          message.payIn = reader.double();
          continue;
        case 6:
          if (tag !== 49) {
            break;
          }

          message.payOut = reader.double();
          continue;
        case 7:
          if (tag !== 57) {
            break;
          }

          message.payInDelta = reader.double();
          continue;
        case 8:
          if (tag !== 65) {
            break;
          }

          message.payOutDelta = reader.double();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateTradingAccountLimitsRequest {
    return {
      accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : "",
      collateralCash: isSet(object.collateralCash) ? globalThis.Number(object.collateralCash) : undefined,
      collateralNonCash: isSet(object.collateralNonCash) ? globalThis.Number(object.collateralNonCash) : undefined,
      openingBalance: isSet(object.openingBalance) ? globalThis.Number(object.openingBalance) : undefined,
      payIn: isSet(object.payIn) ? globalThis.Number(object.payIn) : undefined,
      payOut: isSet(object.payOut) ? globalThis.Number(object.payOut) : undefined,
      payInDelta: isSet(object.payInDelta) ? globalThis.Number(object.payInDelta) : undefined,
      payOutDelta: isSet(object.payOutDelta) ? globalThis.Number(object.payOutDelta) : undefined,
    };
  },

  toJSON(message: UpdateTradingAccountLimitsRequest): unknown {
    const obj: any = {};
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    if (message.collateralCash !== undefined) {
      obj.collateralCash = message.collateralCash;
    }
    if (message.collateralNonCash !== undefined) {
      obj.collateralNonCash = message.collateralNonCash;
    }
    if (message.openingBalance !== undefined) {
      obj.openingBalance = message.openingBalance;
    }
    if (message.payIn !== undefined) {
      obj.payIn = message.payIn;
    }
    if (message.payOut !== undefined) {
      obj.payOut = message.payOut;
    }
    if (message.payInDelta !== undefined) {
      obj.payInDelta = message.payInDelta;
    }
    if (message.payOutDelta !== undefined) {
      obj.payOutDelta = message.payOutDelta;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateTradingAccountLimitsRequest>, I>>(
    base?: I,
  ): UpdateTradingAccountLimitsRequest {
    return UpdateTradingAccountLimitsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateTradingAccountLimitsRequest>, I>>(
    object: I,
  ): UpdateTradingAccountLimitsRequest {
    const message = createBaseUpdateTradingAccountLimitsRequest();
    message.accountId = object.accountId ?? "";
    message.collateralCash = object.collateralCash ?? undefined;
    message.collateralNonCash = object.collateralNonCash ?? undefined;
    message.openingBalance = object.openingBalance ?? undefined;
    message.payIn = object.payIn ?? undefined;
    message.payOut = object.payOut ?? undefined;
    message.payInDelta = object.payInDelta ?? undefined;
    message.payOutDelta = object.payOutDelta ?? undefined;
    return message;
  },
};

function createBasePlaceOrModifyOrdersRequest(): PlaceOrModifyOrdersRequest {
  return { tradingAccountId: "", order: [], buyBeforeSell: false };
}

export const PlaceOrModifyOrdersRequest = {
  encode(message: PlaceOrModifyOrdersRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.tradingAccountId !== "") {
      writer.uint32(10).string(message.tradingAccountId);
    }
    for (const v of message.order) {
      Order.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    if (message.buyBeforeSell !== false) {
      writer.uint32(24).bool(message.buyBeforeSell);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PlaceOrModifyOrdersRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlaceOrModifyOrdersRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tradingAccountId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.order.push(Order.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.buyBeforeSell = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlaceOrModifyOrdersRequest {
    return {
      tradingAccountId: isSet(object.tradingAccountId) ? globalThis.String(object.tradingAccountId) : "",
      order: globalThis.Array.isArray(object?.order) ? object.order.map((e: any) => Order.fromJSON(e)) : [],
      buyBeforeSell: isSet(object.buyBeforeSell) ? globalThis.Boolean(object.buyBeforeSell) : false,
    };
  },

  toJSON(message: PlaceOrModifyOrdersRequest): unknown {
    const obj: any = {};
    if (message.tradingAccountId !== "") {
      obj.tradingAccountId = message.tradingAccountId;
    }
    if (message.order?.length) {
      obj.order = message.order.map((e) => Order.toJSON(e));
    }
    if (message.buyBeforeSell !== false) {
      obj.buyBeforeSell = message.buyBeforeSell;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlaceOrModifyOrdersRequest>, I>>(base?: I): PlaceOrModifyOrdersRequest {
    return PlaceOrModifyOrdersRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlaceOrModifyOrdersRequest>, I>>(object: I): PlaceOrModifyOrdersRequest {
    const message = createBasePlaceOrModifyOrdersRequest();
    message.tradingAccountId = object.tradingAccountId ?? "";
    message.order = object.order?.map((e) => Order.fromPartial(e)) || [];
    message.buyBeforeSell = object.buyBeforeSell ?? false;
    return message;
  },
};

function createBasePlaceOrModifyOrdersResponse(): PlaceOrModifyOrdersResponse {
  return { orderResponse: [] };
}

export const PlaceOrModifyOrdersResponse = {
  encode(message: PlaceOrModifyOrdersResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.orderResponse) {
      OrderResponse.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PlaceOrModifyOrdersResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlaceOrModifyOrdersResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.orderResponse.push(OrderResponse.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlaceOrModifyOrdersResponse {
    return {
      orderResponse: globalThis.Array.isArray(object?.orderResponse)
        ? object.orderResponse.map((e: any) => OrderResponse.fromJSON(e))
        : [],
    };
  },

  toJSON(message: PlaceOrModifyOrdersResponse): unknown {
    const obj: any = {};
    if (message.orderResponse?.length) {
      obj.orderResponse = message.orderResponse.map((e) => OrderResponse.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlaceOrModifyOrdersResponse>, I>>(base?: I): PlaceOrModifyOrdersResponse {
    return PlaceOrModifyOrdersResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlaceOrModifyOrdersResponse>, I>>(object: I): PlaceOrModifyOrdersResponse {
    const message = createBasePlaceOrModifyOrdersResponse();
    message.orderResponse = object.orderResponse?.map((e) => OrderResponse.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCancelOrdersRequest(): CancelOrdersRequest {
  return { tradingAccountId: "", orderId: [] };
}

export const CancelOrdersRequest = {
  encode(message: CancelOrdersRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.tradingAccountId !== "") {
      writer.uint32(10).string(message.tradingAccountId);
    }
    for (const v of message.orderId) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CancelOrdersRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCancelOrdersRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tradingAccountId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.orderId.push(reader.string());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CancelOrdersRequest {
    return {
      tradingAccountId: isSet(object.tradingAccountId) ? globalThis.String(object.tradingAccountId) : "",
      orderId: globalThis.Array.isArray(object?.orderId) ? object.orderId.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: CancelOrdersRequest): unknown {
    const obj: any = {};
    if (message.tradingAccountId !== "") {
      obj.tradingAccountId = message.tradingAccountId;
    }
    if (message.orderId?.length) {
      obj.orderId = message.orderId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CancelOrdersRequest>, I>>(base?: I): CancelOrdersRequest {
    return CancelOrdersRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CancelOrdersRequest>, I>>(object: I): CancelOrdersRequest {
    const message = createBaseCancelOrdersRequest();
    message.tradingAccountId = object.tradingAccountId ?? "";
    message.orderId = object.orderId?.map((e) => e) || [];
    return message;
  },
};

function createBaseCancelOrdersResponse(): CancelOrdersResponse {
  return { orderResponse: [] };
}

export const CancelOrdersResponse = {
  encode(message: CancelOrdersResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.orderResponse) {
      OrderResponse.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CancelOrdersResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCancelOrdersResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.orderResponse.push(OrderResponse.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CancelOrdersResponse {
    return {
      orderResponse: globalThis.Array.isArray(object?.orderResponse)
        ? object.orderResponse.map((e: any) => OrderResponse.fromJSON(e))
        : [],
    };
  },

  toJSON(message: CancelOrdersResponse): unknown {
    const obj: any = {};
    if (message.orderResponse?.length) {
      obj.orderResponse = message.orderResponse.map((e) => OrderResponse.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CancelOrdersResponse>, I>>(base?: I): CancelOrdersResponse {
    return CancelOrdersResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CancelOrdersResponse>, I>>(object: I): CancelOrdersResponse {
    const message = createBaseCancelOrdersResponse();
    message.orderResponse = object.orderResponse?.map((e) => OrderResponse.fromPartial(e)) || [];
    return message;
  },
};

function createBaseOrderResponse(): OrderResponse {
  return {
    successful: false,
    clientOrderId: "",
    orderId: "",
    brokerOrderId: "",
    errorMessage: "",
    commitOrder: false,
    order: undefined,
    zenithTradingUser: "",
  };
}

export const OrderResponse = {
  encode(message: OrderResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.successful !== false) {
      writer.uint32(8).bool(message.successful);
    }
    if (message.clientOrderId !== "") {
      writer.uint32(18).string(message.clientOrderId);
    }
    if (message.orderId !== "") {
      writer.uint32(50).string(message.orderId);
    }
    if (message.brokerOrderId !== "") {
      writer.uint32(26).string(message.brokerOrderId);
    }
    if (message.errorMessage !== "") {
      writer.uint32(34).string(message.errorMessage);
    }
    if (message.commitOrder !== false) {
      writer.uint32(40).bool(message.commitOrder);
    }
    if (message.order !== undefined) {
      Order.encode(message.order, writer.uint32(58).fork()).ldelim();
    }
    if (message.zenithTradingUser !== "") {
      writer.uint32(66).string(message.zenithTradingUser);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OrderResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrderResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.successful = reader.bool();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.clientOrderId = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.orderId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.brokerOrderId = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.errorMessage = reader.string();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.commitOrder = reader.bool();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.order = Order.decode(reader, reader.uint32());
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.zenithTradingUser = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrderResponse {
    return {
      successful: isSet(object.successful) ? globalThis.Boolean(object.successful) : false,
      clientOrderId: isSet(object.clientOrderId) ? globalThis.String(object.clientOrderId) : "",
      orderId: isSet(object.orderId) ? globalThis.String(object.orderId) : "",
      brokerOrderId: isSet(object.brokerOrderId) ? globalThis.String(object.brokerOrderId) : "",
      errorMessage: isSet(object.errorMessage) ? globalThis.String(object.errorMessage) : "",
      commitOrder: isSet(object.commitOrder) ? globalThis.Boolean(object.commitOrder) : false,
      order: isSet(object.order) ? Order.fromJSON(object.order) : undefined,
      zenithTradingUser: isSet(object.zenithTradingUser) ? globalThis.String(object.zenithTradingUser) : "",
    };
  },

  toJSON(message: OrderResponse): unknown {
    const obj: any = {};
    if (message.successful !== false) {
      obj.successful = message.successful;
    }
    if (message.clientOrderId !== "") {
      obj.clientOrderId = message.clientOrderId;
    }
    if (message.orderId !== "") {
      obj.orderId = message.orderId;
    }
    if (message.brokerOrderId !== "") {
      obj.brokerOrderId = message.brokerOrderId;
    }
    if (message.errorMessage !== "") {
      obj.errorMessage = message.errorMessage;
    }
    if (message.commitOrder !== false) {
      obj.commitOrder = message.commitOrder;
    }
    if (message.order !== undefined) {
      obj.order = Order.toJSON(message.order);
    }
    if (message.zenithTradingUser !== "") {
      obj.zenithTradingUser = message.zenithTradingUser;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrderResponse>, I>>(base?: I): OrderResponse {
    return OrderResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrderResponse>, I>>(object: I): OrderResponse {
    const message = createBaseOrderResponse();
    message.successful = object.successful ?? false;
    message.clientOrderId = object.clientOrderId ?? "";
    message.orderId = object.orderId ?? "";
    message.brokerOrderId = object.brokerOrderId ?? "";
    message.errorMessage = object.errorMessage ?? "";
    message.commitOrder = object.commitOrder ?? false;
    message.order = (object.order !== undefined && object.order !== null) ? Order.fromPartial(object.order) : undefined;
    message.zenithTradingUser = object.zenithTradingUser ?? "";
    return message;
  },
};

function createBaseGetOrderRequest(): GetOrderRequest {
  return { accountId: "", orderId: "" };
}

export const GetOrderRequest = {
  encode(message: GetOrderRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.accountId !== "") {
      writer.uint32(18).string(message.accountId);
    }
    if (message.orderId !== "") {
      writer.uint32(26).string(message.orderId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetOrderRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOrderRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.accountId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.orderId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOrderRequest {
    return {
      accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : "",
      orderId: isSet(object.orderId) ? globalThis.String(object.orderId) : "",
    };
  },

  toJSON(message: GetOrderRequest): unknown {
    const obj: any = {};
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    if (message.orderId !== "") {
      obj.orderId = message.orderId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOrderRequest>, I>>(base?: I): GetOrderRequest {
    return GetOrderRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetOrderRequest>, I>>(object: I): GetOrderRequest {
    const message = createBaseGetOrderRequest();
    message.accountId = object.accountId ?? "";
    message.orderId = object.orderId ?? "";
    return message;
  },
};

function createBaseGetAllOrdersRequest(): GetAllOrdersRequest {
  return { tradingAccountId: "" };
}

export const GetAllOrdersRequest = {
  encode(message: GetAllOrdersRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.tradingAccountId !== "") {
      writer.uint32(10).string(message.tradingAccountId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetAllOrdersRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAllOrdersRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tradingAccountId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAllOrdersRequest {
    return { tradingAccountId: isSet(object.tradingAccountId) ? globalThis.String(object.tradingAccountId) : "" };
  },

  toJSON(message: GetAllOrdersRequest): unknown {
    const obj: any = {};
    if (message.tradingAccountId !== "") {
      obj.tradingAccountId = message.tradingAccountId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAllOrdersRequest>, I>>(base?: I): GetAllOrdersRequest {
    return GetAllOrdersRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAllOrdersRequest>, I>>(object: I): GetAllOrdersRequest {
    const message = createBaseGetAllOrdersRequest();
    message.tradingAccountId = object.tradingAccountId ?? "";
    return message;
  },
};

function createBaseTradingAccountUpdate(): TradingAccountUpdate {
  return { userId: "", tradingAccountId: "", orders: [], positions: [], margin: undefined };
}

export const TradingAccountUpdate = {
  encode(message: TradingAccountUpdate, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.userId !== "") {
      writer.uint32(10).string(message.userId);
    }
    if (message.tradingAccountId !== "") {
      writer.uint32(18).string(message.tradingAccountId);
    }
    for (const v of message.orders) {
      Order.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    for (const v of message.positions) {
      Position1.encode(v!, writer.uint32(42).fork()).ldelim();
    }
    if (message.margin !== undefined) {
      TradingAccountMargin.encode(message.margin, writer.uint32(50).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TradingAccountUpdate {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTradingAccountUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.tradingAccountId = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.orders.push(Order.decode(reader, reader.uint32()));
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.positions.push(Position1.decode(reader, reader.uint32()));
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.margin = TradingAccountMargin.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TradingAccountUpdate {
    return {
      userId: isSet(object.userId) ? globalThis.String(object.userId) : "",
      tradingAccountId: isSet(object.tradingAccountId) ? globalThis.String(object.tradingAccountId) : "",
      orders: globalThis.Array.isArray(object?.orders) ? object.orders.map((e: any) => Order.fromJSON(e)) : [],
      positions: globalThis.Array.isArray(object?.positions)
        ? object.positions.map((e: any) => Position1.fromJSON(e))
        : [],
      margin: isSet(object.margin) ? TradingAccountMargin.fromJSON(object.margin) : undefined,
    };
  },

  toJSON(message: TradingAccountUpdate): unknown {
    const obj: any = {};
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.tradingAccountId !== "") {
      obj.tradingAccountId = message.tradingAccountId;
    }
    if (message.orders?.length) {
      obj.orders = message.orders.map((e) => Order.toJSON(e));
    }
    if (message.positions?.length) {
      obj.positions = message.positions.map((e) => Position1.toJSON(e));
    }
    if (message.margin !== undefined) {
      obj.margin = TradingAccountMargin.toJSON(message.margin);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TradingAccountUpdate>, I>>(base?: I): TradingAccountUpdate {
    return TradingAccountUpdate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TradingAccountUpdate>, I>>(object: I): TradingAccountUpdate {
    const message = createBaseTradingAccountUpdate();
    message.userId = object.userId ?? "";
    message.tradingAccountId = object.tradingAccountId ?? "";
    message.orders = object.orders?.map((e) => Order.fromPartial(e)) || [];
    message.positions = object.positions?.map((e) => Position1.fromPartial(e)) || [];
    message.margin = (object.margin !== undefined && object.margin !== null)
      ? TradingAccountMargin.fromPartial(object.margin)
      : undefined;
    return message;
  },
};

function createBasePosition(): Position {
  return {
    security: undefined,
    product: 0,
    quantity: 0,
    overnightQuantity: 0,
    overnightValue: 0,
    buyQuantity: 0,
    sellQuantity: 0,
    buyValue: 0,
    sellValue: 0,
    dayBuyQuantity: 0,
    dayBuyValue: 0,
    daySellQuantity: 0,
    daySellValue: 0,
  };
}

export const Position = {
  encode(message: Position, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(18).fork()).ldelim();
    }
    if (message.product !== 0) {
      writer.uint32(32).int32(message.product);
    }
    if (message.quantity !== 0) {
      writer.uint32(144).int32(message.quantity);
    }
    if (message.overnightQuantity !== 0) {
      writer.uint32(152).int32(message.overnightQuantity);
    }
    if (message.overnightValue !== 0) {
      writer.uint32(161).double(message.overnightValue);
    }
    if (message.buyQuantity !== 0) {
      writer.uint32(48).int32(message.buyQuantity);
    }
    if (message.sellQuantity !== 0) {
      writer.uint32(64).int32(message.sellQuantity);
    }
    if (message.buyValue !== 0) {
      writer.uint32(81).double(message.buyValue);
    }
    if (message.sellValue !== 0) {
      writer.uint32(97).double(message.sellValue);
    }
    if (message.dayBuyQuantity !== 0) {
      writer.uint32(104).int32(message.dayBuyQuantity);
    }
    if (message.dayBuyValue !== 0) {
      writer.uint32(113).double(message.dayBuyValue);
    }
    if (message.daySellQuantity !== 0) {
      writer.uint32(120).int32(message.daySellQuantity);
    }
    if (message.daySellValue !== 0) {
      writer.uint32(129).double(message.daySellValue);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Position {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePosition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.product = reader.int32() as any;
          continue;
        case 18:
          if (tag !== 144) {
            break;
          }

          message.quantity = reader.int32();
          continue;
        case 19:
          if (tag !== 152) {
            break;
          }

          message.overnightQuantity = reader.int32();
          continue;
        case 20:
          if (tag !== 161) {
            break;
          }

          message.overnightValue = reader.double();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.buyQuantity = reader.int32();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.sellQuantity = reader.int32();
          continue;
        case 10:
          if (tag !== 81) {
            break;
          }

          message.buyValue = reader.double();
          continue;
        case 12:
          if (tag !== 97) {
            break;
          }

          message.sellValue = reader.double();
          continue;
        case 13:
          if (tag !== 104) {
            break;
          }

          message.dayBuyQuantity = reader.int32();
          continue;
        case 14:
          if (tag !== 113) {
            break;
          }

          message.dayBuyValue = reader.double();
          continue;
        case 15:
          if (tag !== 120) {
            break;
          }

          message.daySellQuantity = reader.int32();
          continue;
        case 16:
          if (tag !== 129) {
            break;
          }

          message.daySellValue = reader.double();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Position {
    return {
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
      product: isSet(object.product) ? productFromJSON(object.product) : 0,
      quantity: isSet(object.quantity) ? globalThis.Number(object.quantity) : 0,
      overnightQuantity: isSet(object.overnightQuantity) ? globalThis.Number(object.overnightQuantity) : 0,
      overnightValue: isSet(object.overnightValue) ? globalThis.Number(object.overnightValue) : 0,
      buyQuantity: isSet(object.buyQuantity) ? globalThis.Number(object.buyQuantity) : 0,
      sellQuantity: isSet(object.sellQuantity) ? globalThis.Number(object.sellQuantity) : 0,
      buyValue: isSet(object.buyValue) ? globalThis.Number(object.buyValue) : 0,
      sellValue: isSet(object.sellValue) ? globalThis.Number(object.sellValue) : 0,
      dayBuyQuantity: isSet(object.dayBuyQuantity) ? globalThis.Number(object.dayBuyQuantity) : 0,
      dayBuyValue: isSet(object.dayBuyValue) ? globalThis.Number(object.dayBuyValue) : 0,
      daySellQuantity: isSet(object.daySellQuantity) ? globalThis.Number(object.daySellQuantity) : 0,
      daySellValue: isSet(object.daySellValue) ? globalThis.Number(object.daySellValue) : 0,
    };
  },

  toJSON(message: Position): unknown {
    const obj: any = {};
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    if (message.product !== 0) {
      obj.product = productToJSON(message.product);
    }
    if (message.quantity !== 0) {
      obj.quantity = Math.round(message.quantity);
    }
    if (message.overnightQuantity !== 0) {
      obj.overnightQuantity = Math.round(message.overnightQuantity);
    }
    if (message.overnightValue !== 0) {
      obj.overnightValue = message.overnightValue;
    }
    if (message.buyQuantity !== 0) {
      obj.buyQuantity = Math.round(message.buyQuantity);
    }
    if (message.sellQuantity !== 0) {
      obj.sellQuantity = Math.round(message.sellQuantity);
    }
    if (message.buyValue !== 0) {
      obj.buyValue = message.buyValue;
    }
    if (message.sellValue !== 0) {
      obj.sellValue = message.sellValue;
    }
    if (message.dayBuyQuantity !== 0) {
      obj.dayBuyQuantity = Math.round(message.dayBuyQuantity);
    }
    if (message.dayBuyValue !== 0) {
      obj.dayBuyValue = message.dayBuyValue;
    }
    if (message.daySellQuantity !== 0) {
      obj.daySellQuantity = Math.round(message.daySellQuantity);
    }
    if (message.daySellValue !== 0) {
      obj.daySellValue = message.daySellValue;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Position>, I>>(base?: I): Position {
    return Position.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Position>, I>>(object: I): Position {
    const message = createBasePosition();
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    message.product = object.product ?? 0;
    message.quantity = object.quantity ?? 0;
    message.overnightQuantity = object.overnightQuantity ?? 0;
    message.overnightValue = object.overnightValue ?? 0;
    message.buyQuantity = object.buyQuantity ?? 0;
    message.sellQuantity = object.sellQuantity ?? 0;
    message.buyValue = object.buyValue ?? 0;
    message.sellValue = object.sellValue ?? 0;
    message.dayBuyQuantity = object.dayBuyQuantity ?? 0;
    message.dayBuyValue = object.dayBuyValue ?? 0;
    message.daySellQuantity = object.daySellQuantity ?? 0;
    message.daySellValue = object.daySellValue ?? 0;
    return message;
  },
};

function createBaseGetTradingAccountPnlRequest(): GetTradingAccountPnlRequest {
  return { accountId: "" };
}

export const GetTradingAccountPnlRequest = {
  encode(message: GetTradingAccountPnlRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.accountId !== "") {
      writer.uint32(18).string(message.accountId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetTradingAccountPnlRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTradingAccountPnlRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.accountId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetTradingAccountPnlRequest {
    return { accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : "" };
  },

  toJSON(message: GetTradingAccountPnlRequest): unknown {
    const obj: any = {};
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetTradingAccountPnlRequest>, I>>(base?: I): GetTradingAccountPnlRequest {
    return GetTradingAccountPnlRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetTradingAccountPnlRequest>, I>>(object: I): GetTradingAccountPnlRequest {
    const message = createBaseGetTradingAccountPnlRequest();
    message.accountId = object.accountId ?? "";
    return message;
  },
};

function createBaseTradingAccountPnl(): TradingAccountPnl {
  return { accountId: "", dayProfit: 0, monthProfit: 0 };
}

export const TradingAccountPnl = {
  encode(message: TradingAccountPnl, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.accountId !== "") {
      writer.uint32(10).string(message.accountId);
    }
    if (message.dayProfit !== 0) {
      writer.uint32(16).int32(message.dayProfit);
    }
    if (message.monthProfit !== 0) {
      writer.uint32(24).int32(message.monthProfit);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TradingAccountPnl {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTradingAccountPnl();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.accountId = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.dayProfit = reader.int32();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.monthProfit = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TradingAccountPnl {
    return {
      accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : "",
      dayProfit: isSet(object.dayProfit) ? globalThis.Number(object.dayProfit) : 0,
      monthProfit: isSet(object.monthProfit) ? globalThis.Number(object.monthProfit) : 0,
    };
  },

  toJSON(message: TradingAccountPnl): unknown {
    const obj: any = {};
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    if (message.dayProfit !== 0) {
      obj.dayProfit = Math.round(message.dayProfit);
    }
    if (message.monthProfit !== 0) {
      obj.monthProfit = Math.round(message.monthProfit);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TradingAccountPnl>, I>>(base?: I): TradingAccountPnl {
    return TradingAccountPnl.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TradingAccountPnl>, I>>(object: I): TradingAccountPnl {
    const message = createBaseTradingAccountPnl();
    message.accountId = object.accountId ?? "";
    message.dayProfit = object.dayProfit ?? 0;
    message.monthProfit = object.monthProfit ?? 0;
    return message;
  },
};

function createBaseGetHoldingsRequest(): GetHoldingsRequest {
  return { accountId: "" };
}

export const GetHoldingsRequest = {
  encode(message: GetHoldingsRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.accountId !== "") {
      writer.uint32(10).string(message.accountId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetHoldingsRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetHoldingsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.accountId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetHoldingsRequest {
    return { accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : "" };
  },

  toJSON(message: GetHoldingsRequest): unknown {
    const obj: any = {};
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetHoldingsRequest>, I>>(base?: I): GetHoldingsRequest {
    return GetHoldingsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetHoldingsRequest>, I>>(object: I): GetHoldingsRequest {
    const message = createBaseGetHoldingsRequest();
    message.accountId = object.accountId ?? "";
    return message;
  },
};

function createBaseGetHoldingsResponse(): GetHoldingsResponse {
  return { holdings: [] };
}

export const GetHoldingsResponse = {
  encode(message: GetHoldingsResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.holdings) {
      Holding.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetHoldingsResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetHoldingsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.holdings.push(Holding.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetHoldingsResponse {
    return {
      holdings: globalThis.Array.isArray(object?.holdings) ? object.holdings.map((e: any) => Holding.fromJSON(e)) : [],
    };
  },

  toJSON(message: GetHoldingsResponse): unknown {
    const obj: any = {};
    if (message.holdings?.length) {
      obj.holdings = message.holdings.map((e) => Holding.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetHoldingsResponse>, I>>(base?: I): GetHoldingsResponse {
    return GetHoldingsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetHoldingsResponse>, I>>(object: I): GetHoldingsResponse {
    const message = createBaseGetHoldingsResponse();
    message.holdings = object.holdings?.map((e) => Holding.fromPartial(e)) || [];
    return message;
  },
};

function createBaseHolding(): Holding {
  return { security: undefined, quantity: 0, averageBuyPrice: 0, t1Quantity: 0 };
}

export const Holding = {
  encode(message: Holding, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(10).fork()).ldelim();
    }
    if (message.quantity !== 0) {
      writer.uint32(16).int32(message.quantity);
    }
    if (message.averageBuyPrice !== 0) {
      writer.uint32(24).int32(message.averageBuyPrice);
    }
    if (message.t1Quantity !== 0) {
      writer.uint32(32).int32(message.t1Quantity);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Holding {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHolding();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.quantity = reader.int32();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.averageBuyPrice = reader.int32();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.t1Quantity = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Holding {
    return {
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
      quantity: isSet(object.quantity) ? globalThis.Number(object.quantity) : 0,
      averageBuyPrice: isSet(object.averageBuyPrice) ? globalThis.Number(object.averageBuyPrice) : 0,
      t1Quantity: isSet(object.t1Quantity) ? globalThis.Number(object.t1Quantity) : 0,
    };
  },

  toJSON(message: Holding): unknown {
    const obj: any = {};
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    if (message.quantity !== 0) {
      obj.quantity = Math.round(message.quantity);
    }
    if (message.averageBuyPrice !== 0) {
      obj.averageBuyPrice = Math.round(message.averageBuyPrice);
    }
    if (message.t1Quantity !== 0) {
      obj.t1Quantity = Math.round(message.t1Quantity);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Holding>, I>>(base?: I): Holding {
    return Holding.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Holding>, I>>(object: I): Holding {
    const message = createBaseHolding();
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    message.quantity = object.quantity ?? 0;
    message.averageBuyPrice = object.averageBuyPrice ?? 0;
    message.t1Quantity = object.t1Quantity ?? 0;
    return message;
  },
};

function createBaseGetOrderHistoryRequest(): GetOrderHistoryRequest {
  return { accountId: "", orderId: "" };
}

export const GetOrderHistoryRequest = {
  encode(message: GetOrderHistoryRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.accountId !== "") {
      writer.uint32(10).string(message.accountId);
    }
    if (message.orderId !== "") {
      writer.uint32(18).string(message.orderId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetOrderHistoryRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOrderHistoryRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.accountId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.orderId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOrderHistoryRequest {
    return {
      accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : "",
      orderId: isSet(object.orderId) ? globalThis.String(object.orderId) : "",
    };
  },

  toJSON(message: GetOrderHistoryRequest): unknown {
    const obj: any = {};
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    if (message.orderId !== "") {
      obj.orderId = message.orderId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOrderHistoryRequest>, I>>(base?: I): GetOrderHistoryRequest {
    return GetOrderHistoryRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetOrderHistoryRequest>, I>>(object: I): GetOrderHistoryRequest {
    const message = createBaseGetOrderHistoryRequest();
    message.accountId = object.accountId ?? "";
    message.orderId = object.orderId ?? "";
    return message;
  },
};

function createBaseGetOrderHistoryResponse(): GetOrderHistoryResponse {
  return { orders: [] };
}

export const GetOrderHistoryResponse = {
  encode(message: GetOrderHistoryResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.orders) {
      OrderHistory.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetOrderHistoryResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOrderHistoryResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.orders.push(OrderHistory.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOrderHistoryResponse {
    return {
      orders: globalThis.Array.isArray(object?.orders) ? object.orders.map((e: any) => OrderHistory.fromJSON(e)) : [],
    };
  },

  toJSON(message: GetOrderHistoryResponse): unknown {
    const obj: any = {};
    if (message.orders?.length) {
      obj.orders = message.orders.map((e) => OrderHistory.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOrderHistoryResponse>, I>>(base?: I): GetOrderHistoryResponse {
    return GetOrderHistoryResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetOrderHistoryResponse>, I>>(object: I): GetOrderHistoryResponse {
    const message = createBaseGetOrderHistoryResponse();
    message.orders = object.orders?.map((e) => OrderHistory.fromPartial(e)) || [];
    return message;
  },
};

function createBaseOrderHistory(): OrderHistory {
  return {
    clientOrderId: "",
    orderId: "",
    brokerOrderId: "",
    exchangeOrderId: "",
    security: undefined,
    transactionType: 0,
    orderType: 0,
    quantity: 0,
    product: 0,
    price: 0,
    triggerPrice: 0,
    variety: 0,
    disclosedQuantity: 0,
    validity: 0,
    status: "",
    filledQuantity: 0,
    unfilledQuantity: 0,
    averageTradedPrice: 0,
    secondaryStatus: "",
    exchangeTimestamp: 0,
    message: "",
  };
}

export const OrderHistory = {
  encode(message: OrderHistory, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.clientOrderId !== "") {
      writer.uint32(10).string(message.clientOrderId);
    }
    if (message.orderId !== "") {
      writer.uint32(18).string(message.orderId);
    }
    if (message.brokerOrderId !== "") {
      writer.uint32(26).string(message.brokerOrderId);
    }
    if (message.exchangeOrderId !== "") {
      writer.uint32(34).string(message.exchangeOrderId);
    }
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(42).fork()).ldelim();
    }
    if (message.transactionType !== 0) {
      writer.uint32(48).int32(message.transactionType);
    }
    if (message.orderType !== 0) {
      writer.uint32(56).int32(message.orderType);
    }
    if (message.quantity !== 0) {
      writer.uint32(64).int32(message.quantity);
    }
    if (message.product !== 0) {
      writer.uint32(72).int32(message.product);
    }
    if (message.price !== 0) {
      writer.uint32(80).int32(message.price);
    }
    if (message.triggerPrice !== 0) {
      writer.uint32(88).int32(message.triggerPrice);
    }
    if (message.variety !== 0) {
      writer.uint32(96).int32(message.variety);
    }
    if (message.disclosedQuantity !== 0) {
      writer.uint32(104).int32(message.disclosedQuantity);
    }
    if (message.validity !== 0) {
      writer.uint32(112).int32(message.validity);
    }
    if (message.status !== "") {
      writer.uint32(122).string(message.status);
    }
    if (message.filledQuantity !== 0) {
      writer.uint32(128).int32(message.filledQuantity);
    }
    if (message.unfilledQuantity !== 0) {
      writer.uint32(136).int32(message.unfilledQuantity);
    }
    if (message.averageTradedPrice !== 0) {
      writer.uint32(144).int32(message.averageTradedPrice);
    }
    if (message.secondaryStatus !== "") {
      writer.uint32(154).string(message.secondaryStatus);
    }
    if (message.exchangeTimestamp !== 0) {
      writer.uint32(160).int64(message.exchangeTimestamp);
    }
    if (message.message !== "") {
      writer.uint32(170).string(message.message);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OrderHistory {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrderHistory();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.clientOrderId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.orderId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.brokerOrderId = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.exchangeOrderId = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.transactionType = reader.int32() as any;
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.orderType = reader.int32() as any;
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.quantity = reader.int32();
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.product = reader.int32() as any;
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.price = reader.int32();
          continue;
        case 11:
          if (tag !== 88) {
            break;
          }

          message.triggerPrice = reader.int32();
          continue;
        case 12:
          if (tag !== 96) {
            break;
          }

          message.variety = reader.int32() as any;
          continue;
        case 13:
          if (tag !== 104) {
            break;
          }

          message.disclosedQuantity = reader.int32();
          continue;
        case 14:
          if (tag !== 112) {
            break;
          }

          message.validity = reader.int32() as any;
          continue;
        case 15:
          if (tag !== 122) {
            break;
          }

          message.status = reader.string();
          continue;
        case 16:
          if (tag !== 128) {
            break;
          }

          message.filledQuantity = reader.int32();
          continue;
        case 17:
          if (tag !== 136) {
            break;
          }

          message.unfilledQuantity = reader.int32();
          continue;
        case 18:
          if (tag !== 144) {
            break;
          }

          message.averageTradedPrice = reader.int32();
          continue;
        case 19:
          if (tag !== 154) {
            break;
          }

          message.secondaryStatus = reader.string();
          continue;
        case 20:
          if (tag !== 160) {
            break;
          }

          message.exchangeTimestamp = longToNumber(reader.int64() as Long);
          continue;
        case 21:
          if (tag !== 170) {
            break;
          }

          message.message = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrderHistory {
    return {
      clientOrderId: isSet(object.clientOrderId) ? globalThis.String(object.clientOrderId) : "",
      orderId: isSet(object.orderId) ? globalThis.String(object.orderId) : "",
      brokerOrderId: isSet(object.brokerOrderId) ? globalThis.String(object.brokerOrderId) : "",
      exchangeOrderId: isSet(object.exchangeOrderId) ? globalThis.String(object.exchangeOrderId) : "",
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
      transactionType: isSet(object.transactionType) ? transactionTypeFromJSON(object.transactionType) : 0,
      orderType: isSet(object.orderType) ? broker_OrderTypeFromJSON(object.orderType) : 0,
      quantity: isSet(object.quantity) ? globalThis.Number(object.quantity) : 0,
      product: isSet(object.product) ? productFromJSON(object.product) : 0,
      price: isSet(object.price) ? globalThis.Number(object.price) : 0,
      triggerPrice: isSet(object.triggerPrice) ? globalThis.Number(object.triggerPrice) : 0,
      variety: isSet(object.variety) ? broker_VarietyFromJSON(object.variety) : 0,
      disclosedQuantity: isSet(object.disclosedQuantity) ? globalThis.Number(object.disclosedQuantity) : 0,
      validity: isSet(object.validity) ? validityFromJSON(object.validity) : 0,
      status: isSet(object.status) ? globalThis.String(object.status) : "",
      filledQuantity: isSet(object.filledQuantity) ? globalThis.Number(object.filledQuantity) : 0,
      unfilledQuantity: isSet(object.unfilledQuantity) ? globalThis.Number(object.unfilledQuantity) : 0,
      averageTradedPrice: isSet(object.averageTradedPrice) ? globalThis.Number(object.averageTradedPrice) : 0,
      secondaryStatus: isSet(object.secondaryStatus) ? globalThis.String(object.secondaryStatus) : "",
      exchangeTimestamp: isSet(object.exchangeTimestamp) ? globalThis.Number(object.exchangeTimestamp) : 0,
      message: isSet(object.message) ? globalThis.String(object.message) : "",
    };
  },

  toJSON(message: OrderHistory): unknown {
    const obj: any = {};
    if (message.clientOrderId !== "") {
      obj.clientOrderId = message.clientOrderId;
    }
    if (message.orderId !== "") {
      obj.orderId = message.orderId;
    }
    if (message.brokerOrderId !== "") {
      obj.brokerOrderId = message.brokerOrderId;
    }
    if (message.exchangeOrderId !== "") {
      obj.exchangeOrderId = message.exchangeOrderId;
    }
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    if (message.transactionType !== 0) {
      obj.transactionType = transactionTypeToJSON(message.transactionType);
    }
    if (message.orderType !== 0) {
      obj.orderType = broker_OrderTypeToJSON(message.orderType);
    }
    if (message.quantity !== 0) {
      obj.quantity = Math.round(message.quantity);
    }
    if (message.product !== 0) {
      obj.product = productToJSON(message.product);
    }
    if (message.price !== 0) {
      obj.price = Math.round(message.price);
    }
    if (message.triggerPrice !== 0) {
      obj.triggerPrice = Math.round(message.triggerPrice);
    }
    if (message.variety !== 0) {
      obj.variety = broker_VarietyToJSON(message.variety);
    }
    if (message.disclosedQuantity !== 0) {
      obj.disclosedQuantity = Math.round(message.disclosedQuantity);
    }
    if (message.validity !== 0) {
      obj.validity = validityToJSON(message.validity);
    }
    if (message.status !== "") {
      obj.status = message.status;
    }
    if (message.filledQuantity !== 0) {
      obj.filledQuantity = Math.round(message.filledQuantity);
    }
    if (message.unfilledQuantity !== 0) {
      obj.unfilledQuantity = Math.round(message.unfilledQuantity);
    }
    if (message.averageTradedPrice !== 0) {
      obj.averageTradedPrice = Math.round(message.averageTradedPrice);
    }
    if (message.secondaryStatus !== "") {
      obj.secondaryStatus = message.secondaryStatus;
    }
    if (message.exchangeTimestamp !== 0) {
      obj.exchangeTimestamp = Math.round(message.exchangeTimestamp);
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrderHistory>, I>>(base?: I): OrderHistory {
    return OrderHistory.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrderHistory>, I>>(object: I): OrderHistory {
    const message = createBaseOrderHistory();
    message.clientOrderId = object.clientOrderId ?? "";
    message.orderId = object.orderId ?? "";
    message.brokerOrderId = object.brokerOrderId ?? "";
    message.exchangeOrderId = object.exchangeOrderId ?? "";
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    message.transactionType = object.transactionType ?? 0;
    message.orderType = object.orderType ?? 0;
    message.quantity = object.quantity ?? 0;
    message.product = object.product ?? 0;
    message.price = object.price ?? 0;
    message.triggerPrice = object.triggerPrice ?? 0;
    message.variety = object.variety ?? 0;
    message.disclosedQuantity = object.disclosedQuantity ?? 0;
    message.validity = object.validity ?? 0;
    message.status = object.status ?? "";
    message.filledQuantity = object.filledQuantity ?? 0;
    message.unfilledQuantity = object.unfilledQuantity ?? 0;
    message.averageTradedPrice = object.averageTradedPrice ?? 0;
    message.secondaryStatus = object.secondaryStatus ?? "";
    message.exchangeTimestamp = object.exchangeTimestamp ?? 0;
    message.message = object.message ?? "";
    return message;
  },
};

function createBaseGetOrderTradeHistoryRequest(): GetOrderTradeHistoryRequest {
  return { accountId: "", orderId: "" };
}

export const GetOrderTradeHistoryRequest = {
  encode(message: GetOrderTradeHistoryRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.accountId !== "") {
      writer.uint32(10).string(message.accountId);
    }
    if (message.orderId !== "") {
      writer.uint32(18).string(message.orderId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetOrderTradeHistoryRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOrderTradeHistoryRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.accountId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.orderId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOrderTradeHistoryRequest {
    return {
      accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : "",
      orderId: isSet(object.orderId) ? globalThis.String(object.orderId) : "",
    };
  },

  toJSON(message: GetOrderTradeHistoryRequest): unknown {
    const obj: any = {};
    if (message.accountId !== "") {
      obj.accountId = message.accountId;
    }
    if (message.orderId !== "") {
      obj.orderId = message.orderId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOrderTradeHistoryRequest>, I>>(base?: I): GetOrderTradeHistoryRequest {
    return GetOrderTradeHistoryRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetOrderTradeHistoryRequest>, I>>(object: I): GetOrderTradeHistoryRequest {
    const message = createBaseGetOrderTradeHistoryRequest();
    message.accountId = object.accountId ?? "";
    message.orderId = object.orderId ?? "";
    return message;
  },
};

function createBaseGetOrderTradeHistoryResponse(): GetOrderTradeHistoryResponse {
  return { trades: [] };
}

export const GetOrderTradeHistoryResponse = {
  encode(message: GetOrderTradeHistoryResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.trades) {
      Trade.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetOrderTradeHistoryResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOrderTradeHistoryResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.trades.push(Trade.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOrderTradeHistoryResponse {
    return { trades: globalThis.Array.isArray(object?.trades) ? object.trades.map((e: any) => Trade.fromJSON(e)) : [] };
  },

  toJSON(message: GetOrderTradeHistoryResponse): unknown {
    const obj: any = {};
    if (message.trades?.length) {
      obj.trades = message.trades.map((e) => Trade.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOrderTradeHistoryResponse>, I>>(base?: I): GetOrderTradeHistoryResponse {
    return GetOrderTradeHistoryResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetOrderTradeHistoryResponse>, I>>(object: I): GetOrderTradeHistoryResponse {
    const message = createBaseGetOrderTradeHistoryResponse();
    message.trades = object.trades?.map((e) => Trade.fromPartial(e)) || [];
    return message;
  },
};

export interface TradingAccountService {
  GetBrokers(request: GetBrokersRequest): Promise<Brokers>;
  ChangePrimaryTradingAccount(request: ChangePrimaryTradingAccountRequest): Promise<TradingAccounts>;
  GetTradingAccounts(request: Empty): Promise<TradingAccounts>;
  GetTradingAccountMargin(request: GetTradingAccountMarginRequest): Promise<TradingAccountMargin>;
  GetTradingAccountPnl(request: GetTradingAccountPnlRequest): Promise<TradingAccountPnl>;
  GetUsersForTradingAccountAdmin(request: GetUsersForTradingAccountRequest): Promise<GetUsersForTradingAccountResponse>;
  SetDebugForTradingAccountAdmin(request: SetDebugForTradingAccountRequest): Promise<Empty>;
  CalculateMargin(request: MarginFromBrokerRequest): Promise<MarginFromBrokerResponse>;
  CalculateMarginWithoutUser(request: MarginFromBrokerRequest): Promise<MarginFromBrokerResponse>;
  /**
   * ---- Demat account opening (KYC via Digio) ----
   * User-facing:
   */
  InitiateDematApplication(request: InitiateDematApplicationRequest): Promise<InitiateDematApplicationResponse>;
  GetDematApplicationStatus(request: GetDematApplicationStatusRequest): Promise<GetDematApplicationStatusResponse>;
  /** Webhook (called by scorpius; signature verified in draco): */
  HandleDigioWebhook(request: HandleDigioWebhookRequest): Promise<HandleDigioWebhookResponse>;
  /** Admin / compliance: */
  GetDematApplicationsAdmin(request: GetDematApplicationsAdminRequest): Promise<GetDematApplicationsAdminResponse>;
  GetDematApplicationAdmin(request: GetDematApplicationAdminRequest): Promise<TradingAccount>;
  ActivateTradingAccount(request: ActivateTradingAccountRequest): Promise<TradingAccount>;
  RejectDematApplication(request: RejectDematApplicationRequest): Promise<Empty>;
  /** ---- Account profile (bank / nominee / demat) — user-facing (userId from metadata) ---- */
  GetAccountProfile(request: GetAccountProfileRequest): Promise<TradingAccount>;
  AddBankAccount(request: BankAccountRequest): Promise<TradingAccount>;
  UpdateBankAccount(request: BankAccountRequest): Promise<TradingAccount>;
  RemoveBankAccount(request: RemoveBankAccountRequest): Promise<TradingAccount>;
  SetPrimaryBankAccount(request: SetPrimaryBankAccountRequest): Promise<TradingAccount>;
  UpsertNominees(request: UpsertNomineesRequest): Promise<TradingAccount>;
  GetNomineeChangeRequest(request: GetNomineeChangeRequestRequest): Promise<NomineeChangeRequest>;
  SubmitNomineeChangeRequest(request: UpsertNomineesRequest): Promise<NomineeChangeRequest>;
  AddDematAccount(request: DematAccountRequest): Promise<TradingAccount>;
  UpdateDematAccount(request: DematAccountRequest): Promise<TradingAccount>;
  RemoveDematAccount(request: RemoveDematAccountRequest): Promise<TradingAccount>;
  /**
   * Returns a short-lived presigned S3 PUT URL the client uploads a proof to; creates the
   * account_document row (PENDING) so the returned document_id can be set as a proof reference.
   */
  CreateDocumentUploadUrl(request: CreateDocumentUploadUrlRequest): Promise<CreateDocumentUploadUrlResponse>;
  /** ---- Self-service kill switch (user-driven cool-off; cannot be cancelled before it expires) ---- */
  SetKillSwitch(request: SetKillSwitchRequest): Promise<TradingAccount>;
  GetKillSwitchStatus(request: GetKillSwitchStatusRequest): Promise<KillSwitchStatusResponse>;
  /** ---- Practice trade ---- */
  ResetPracticeTradingAccount(request: ResetPracticeTradingAccountRequest): Promise<TradingAccounts>;
  SetPracticeTradeEnabled(request: SetPracticeTradeEnabledRequest): Promise<TradingAccounts>;
  /** ---- Admin: segment activation + verification ---- */
  SetSegmentActivation(request: SetSegmentActivationRequest): Promise<TradingAccount>;
  VerifyBankAccount(request: VerifyBankAccountRequest): Promise<TradingAccount>;
  VerifyDematAccount(request: VerifyDematAccountRequest): Promise<TradingAccount>;
  VerifyDocument(request: VerifyDocumentRequest): Promise<TradingAccount>;
  ApproveNomineeChangeRequest(request: ApproveNomineeChangeRequestRequest): Promise<TradingAccount>;
  RejectNomineeChangeRequest(request: RejectNomineeChangeRequestRequest): Promise<NomineeChangeRequest>;
  /** Back-office: update Besseggen collateral / ledger columns in DB and refresh Hazelcast limits. */
  UpdateTradingAccountLimits(request: UpdateTradingAccountLimitsRequest): Promise<TradingAccountMargin>;
}

export const TradingAccountServiceServiceName = "com.tick2trade.api.tradingbridge.TradingAccountService";
export class TradingAccountServiceClientImpl implements TradingAccountService {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || TradingAccountServiceServiceName;
    this.rpc = rpc;
    this.GetBrokers = this.GetBrokers.bind(this);
    this.ChangePrimaryTradingAccount = this.ChangePrimaryTradingAccount.bind(this);
    this.GetTradingAccounts = this.GetTradingAccounts.bind(this);
    this.GetTradingAccountMargin = this.GetTradingAccountMargin.bind(this);
    this.GetTradingAccountPnl = this.GetTradingAccountPnl.bind(this);
    this.GetUsersForTradingAccountAdmin = this.GetUsersForTradingAccountAdmin.bind(this);
    this.SetDebugForTradingAccountAdmin = this.SetDebugForTradingAccountAdmin.bind(this);
    this.CalculateMargin = this.CalculateMargin.bind(this);
    this.CalculateMarginWithoutUser = this.CalculateMarginWithoutUser.bind(this);
    this.InitiateDematApplication = this.InitiateDematApplication.bind(this);
    this.GetDematApplicationStatus = this.GetDematApplicationStatus.bind(this);
    this.HandleDigioWebhook = this.HandleDigioWebhook.bind(this);
    this.GetDematApplicationsAdmin = this.GetDematApplicationsAdmin.bind(this);
    this.GetDematApplicationAdmin = this.GetDematApplicationAdmin.bind(this);
    this.ActivateTradingAccount = this.ActivateTradingAccount.bind(this);
    this.RejectDematApplication = this.RejectDematApplication.bind(this);
    this.GetAccountProfile = this.GetAccountProfile.bind(this);
    this.AddBankAccount = this.AddBankAccount.bind(this);
    this.UpdateBankAccount = this.UpdateBankAccount.bind(this);
    this.RemoveBankAccount = this.RemoveBankAccount.bind(this);
    this.SetPrimaryBankAccount = this.SetPrimaryBankAccount.bind(this);
    this.UpsertNominees = this.UpsertNominees.bind(this);
    this.GetNomineeChangeRequest = this.GetNomineeChangeRequest.bind(this);
    this.SubmitNomineeChangeRequest = this.SubmitNomineeChangeRequest.bind(this);
    this.AddDematAccount = this.AddDematAccount.bind(this);
    this.UpdateDematAccount = this.UpdateDematAccount.bind(this);
    this.RemoveDematAccount = this.RemoveDematAccount.bind(this);
    this.CreateDocumentUploadUrl = this.CreateDocumentUploadUrl.bind(this);
    this.SetKillSwitch = this.SetKillSwitch.bind(this);
    this.GetKillSwitchStatus = this.GetKillSwitchStatus.bind(this);
    this.ResetPracticeTradingAccount = this.ResetPracticeTradingAccount.bind(this);
    this.SetPracticeTradeEnabled = this.SetPracticeTradeEnabled.bind(this);
    this.SetSegmentActivation = this.SetSegmentActivation.bind(this);
    this.VerifyBankAccount = this.VerifyBankAccount.bind(this);
    this.VerifyDematAccount = this.VerifyDematAccount.bind(this);
    this.VerifyDocument = this.VerifyDocument.bind(this);
    this.ApproveNomineeChangeRequest = this.ApproveNomineeChangeRequest.bind(this);
    this.RejectNomineeChangeRequest = this.RejectNomineeChangeRequest.bind(this);
    this.UpdateTradingAccountLimits = this.UpdateTradingAccountLimits.bind(this);
  }
  GetBrokers(request: GetBrokersRequest): Promise<Brokers> {
    const data = GetBrokersRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetBrokers", data);
    return promise.then((data) => Brokers.decode(_m0.Reader.create(data)));
  }

  ChangePrimaryTradingAccount(request: ChangePrimaryTradingAccountRequest): Promise<TradingAccounts> {
    const data = ChangePrimaryTradingAccountRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "ChangePrimaryTradingAccount", data);
    return promise.then((data) => TradingAccounts.decode(_m0.Reader.create(data)));
  }

  GetTradingAccounts(request: Empty): Promise<TradingAccounts> {
    const data = Empty.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetTradingAccounts", data);
    return promise.then((data) => TradingAccounts.decode(_m0.Reader.create(data)));
  }

  GetTradingAccountMargin(request: GetTradingAccountMarginRequest): Promise<TradingAccountMargin> {
    const data = GetTradingAccountMarginRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetTradingAccountMargin", data);
    return promise.then((data) => TradingAccountMargin.decode(_m0.Reader.create(data)));
  }

  GetTradingAccountPnl(request: GetTradingAccountPnlRequest): Promise<TradingAccountPnl> {
    const data = GetTradingAccountPnlRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetTradingAccountPnl", data);
    return promise.then((data) => TradingAccountPnl.decode(_m0.Reader.create(data)));
  }

  GetUsersForTradingAccountAdmin(
    request: GetUsersForTradingAccountRequest,
  ): Promise<GetUsersForTradingAccountResponse> {
    const data = GetUsersForTradingAccountRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetUsersForTradingAccountAdmin", data);
    return promise.then((data) => GetUsersForTradingAccountResponse.decode(_m0.Reader.create(data)));
  }

  SetDebugForTradingAccountAdmin(request: SetDebugForTradingAccountRequest): Promise<Empty> {
    const data = SetDebugForTradingAccountRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "SetDebugForTradingAccountAdmin", data);
    return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
  }

  CalculateMargin(request: MarginFromBrokerRequest): Promise<MarginFromBrokerResponse> {
    const data = MarginFromBrokerRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "CalculateMargin", data);
    return promise.then((data) => MarginFromBrokerResponse.decode(_m0.Reader.create(data)));
  }

  CalculateMarginWithoutUser(request: MarginFromBrokerRequest): Promise<MarginFromBrokerResponse> {
    const data = MarginFromBrokerRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "CalculateMarginWithoutUser", data);
    return promise.then((data) => MarginFromBrokerResponse.decode(_m0.Reader.create(data)));
  }

  InitiateDematApplication(request: InitiateDematApplicationRequest): Promise<InitiateDematApplicationResponse> {
    const data = InitiateDematApplicationRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "InitiateDematApplication", data);
    return promise.then((data) => InitiateDematApplicationResponse.decode(_m0.Reader.create(data)));
  }

  GetDematApplicationStatus(request: GetDematApplicationStatusRequest): Promise<GetDematApplicationStatusResponse> {
    const data = GetDematApplicationStatusRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetDematApplicationStatus", data);
    return promise.then((data) => GetDematApplicationStatusResponse.decode(_m0.Reader.create(data)));
  }

  HandleDigioWebhook(request: HandleDigioWebhookRequest): Promise<HandleDigioWebhookResponse> {
    const data = HandleDigioWebhookRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "HandleDigioWebhook", data);
    return promise.then((data) => HandleDigioWebhookResponse.decode(_m0.Reader.create(data)));
  }

  GetDematApplicationsAdmin(request: GetDematApplicationsAdminRequest): Promise<GetDematApplicationsAdminResponse> {
    const data = GetDematApplicationsAdminRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetDematApplicationsAdmin", data);
    return promise.then((data) => GetDematApplicationsAdminResponse.decode(_m0.Reader.create(data)));
  }

  GetDematApplicationAdmin(request: GetDematApplicationAdminRequest): Promise<TradingAccount> {
    const data = GetDematApplicationAdminRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetDematApplicationAdmin", data);
    return promise.then((data) => TradingAccount.decode(_m0.Reader.create(data)));
  }

  ActivateTradingAccount(request: ActivateTradingAccountRequest): Promise<TradingAccount> {
    const data = ActivateTradingAccountRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "ActivateTradingAccount", data);
    return promise.then((data) => TradingAccount.decode(_m0.Reader.create(data)));
  }

  RejectDematApplication(request: RejectDematApplicationRequest): Promise<Empty> {
    const data = RejectDematApplicationRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "RejectDematApplication", data);
    return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
  }

  GetAccountProfile(request: GetAccountProfileRequest): Promise<TradingAccount> {
    const data = GetAccountProfileRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetAccountProfile", data);
    return promise.then((data) => TradingAccount.decode(_m0.Reader.create(data)));
  }

  AddBankAccount(request: BankAccountRequest): Promise<TradingAccount> {
    const data = BankAccountRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "AddBankAccount", data);
    return promise.then((data) => TradingAccount.decode(_m0.Reader.create(data)));
  }

  UpdateBankAccount(request: BankAccountRequest): Promise<TradingAccount> {
    const data = BankAccountRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "UpdateBankAccount", data);
    return promise.then((data) => TradingAccount.decode(_m0.Reader.create(data)));
  }

  RemoveBankAccount(request: RemoveBankAccountRequest): Promise<TradingAccount> {
    const data = RemoveBankAccountRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "RemoveBankAccount", data);
    return promise.then((data) => TradingAccount.decode(_m0.Reader.create(data)));
  }

  SetPrimaryBankAccount(request: SetPrimaryBankAccountRequest): Promise<TradingAccount> {
    const data = SetPrimaryBankAccountRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "SetPrimaryBankAccount", data);
    return promise.then((data) => TradingAccount.decode(_m0.Reader.create(data)));
  }

  UpsertNominees(request: UpsertNomineesRequest): Promise<TradingAccount> {
    const data = UpsertNomineesRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "UpsertNominees", data);
    return promise.then((data) => TradingAccount.decode(_m0.Reader.create(data)));
  }

  GetNomineeChangeRequest(request: GetNomineeChangeRequestRequest): Promise<NomineeChangeRequest> {
    const data = GetNomineeChangeRequestRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetNomineeChangeRequest", data);
    return promise.then((data) => NomineeChangeRequest.decode(_m0.Reader.create(data)));
  }

  SubmitNomineeChangeRequest(request: UpsertNomineesRequest): Promise<NomineeChangeRequest> {
    const data = UpsertNomineesRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "SubmitNomineeChangeRequest", data);
    return promise.then((data) => NomineeChangeRequest.decode(_m0.Reader.create(data)));
  }

  AddDematAccount(request: DematAccountRequest): Promise<TradingAccount> {
    const data = DematAccountRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "AddDematAccount", data);
    return promise.then((data) => TradingAccount.decode(_m0.Reader.create(data)));
  }

  UpdateDematAccount(request: DematAccountRequest): Promise<TradingAccount> {
    const data = DematAccountRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "UpdateDematAccount", data);
    return promise.then((data) => TradingAccount.decode(_m0.Reader.create(data)));
  }

  RemoveDematAccount(request: RemoveDematAccountRequest): Promise<TradingAccount> {
    const data = RemoveDematAccountRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "RemoveDematAccount", data);
    return promise.then((data) => TradingAccount.decode(_m0.Reader.create(data)));
  }

  CreateDocumentUploadUrl(request: CreateDocumentUploadUrlRequest): Promise<CreateDocumentUploadUrlResponse> {
    const data = CreateDocumentUploadUrlRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "CreateDocumentUploadUrl", data);
    return promise.then((data) => CreateDocumentUploadUrlResponse.decode(_m0.Reader.create(data)));
  }

  SetKillSwitch(request: SetKillSwitchRequest): Promise<TradingAccount> {
    const data = SetKillSwitchRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "SetKillSwitch", data);
    return promise.then((data) => TradingAccount.decode(_m0.Reader.create(data)));
  }

  GetKillSwitchStatus(request: GetKillSwitchStatusRequest): Promise<KillSwitchStatusResponse> {
    const data = GetKillSwitchStatusRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetKillSwitchStatus", data);
    return promise.then((data) => KillSwitchStatusResponse.decode(_m0.Reader.create(data)));
  }

  ResetPracticeTradingAccount(request: ResetPracticeTradingAccountRequest): Promise<TradingAccounts> {
    const data = ResetPracticeTradingAccountRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "ResetPracticeTradingAccount", data);
    return promise.then((data) => TradingAccounts.decode(_m0.Reader.create(data)));
  }

  SetPracticeTradeEnabled(request: SetPracticeTradeEnabledRequest): Promise<TradingAccounts> {
    const data = SetPracticeTradeEnabledRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "SetPracticeTradeEnabled", data);
    return promise.then((data) => TradingAccounts.decode(_m0.Reader.create(data)));
  }

  SetSegmentActivation(request: SetSegmentActivationRequest): Promise<TradingAccount> {
    const data = SetSegmentActivationRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "SetSegmentActivation", data);
    return promise.then((data) => TradingAccount.decode(_m0.Reader.create(data)));
  }

  VerifyBankAccount(request: VerifyBankAccountRequest): Promise<TradingAccount> {
    const data = VerifyBankAccountRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "VerifyBankAccount", data);
    return promise.then((data) => TradingAccount.decode(_m0.Reader.create(data)));
  }

  VerifyDematAccount(request: VerifyDematAccountRequest): Promise<TradingAccount> {
    const data = VerifyDematAccountRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "VerifyDematAccount", data);
    return promise.then((data) => TradingAccount.decode(_m0.Reader.create(data)));
  }

  VerifyDocument(request: VerifyDocumentRequest): Promise<TradingAccount> {
    const data = VerifyDocumentRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "VerifyDocument", data);
    return promise.then((data) => TradingAccount.decode(_m0.Reader.create(data)));
  }

  ApproveNomineeChangeRequest(request: ApproveNomineeChangeRequestRequest): Promise<TradingAccount> {
    const data = ApproveNomineeChangeRequestRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "ApproveNomineeChangeRequest", data);
    return promise.then((data) => TradingAccount.decode(_m0.Reader.create(data)));
  }

  RejectNomineeChangeRequest(request: RejectNomineeChangeRequestRequest): Promise<NomineeChangeRequest> {
    const data = RejectNomineeChangeRequestRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "RejectNomineeChangeRequest", data);
    return promise.then((data) => NomineeChangeRequest.decode(_m0.Reader.create(data)));
  }

  UpdateTradingAccountLimits(request: UpdateTradingAccountLimitsRequest): Promise<TradingAccountMargin> {
    const data = UpdateTradingAccountLimitsRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "UpdateTradingAccountLimits", data);
    return promise.then((data) => TradingAccountMargin.decode(_m0.Reader.create(data)));
  }
}

export interface OrderService {
  PlaceOrModifyOrders(request: PlaceOrModifyOrdersRequest): Promise<PlaceOrModifyOrdersResponse>;
  CancelOrders(request: CancelOrdersRequest): Promise<CancelOrdersResponse>;
  GetOrder(request: GetOrderRequest): Promise<Order>;
  GetAllOrders(request: GetAllOrdersRequest): Promise<Orders>;
  GetHoldings(request: GetHoldingsRequest): Promise<GetHoldingsResponse>;
  GetAllOrdersAdmin(request: GetAllOrdersRequest): Promise<Orders>;
  GetOrderHistory(request: GetOrderHistoryRequest): Promise<GetOrderHistoryResponse>;
  GetOrderTradeHistory(request: GetOrderTradeHistoryRequest): Promise<GetOrderTradeHistoryResponse>;
}

export const OrderServiceServiceName = "com.tick2trade.api.tradingbridge.OrderService";
export class OrderServiceClientImpl implements OrderService {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || OrderServiceServiceName;
    this.rpc = rpc;
    this.PlaceOrModifyOrders = this.PlaceOrModifyOrders.bind(this);
    this.CancelOrders = this.CancelOrders.bind(this);
    this.GetOrder = this.GetOrder.bind(this);
    this.GetAllOrders = this.GetAllOrders.bind(this);
    this.GetHoldings = this.GetHoldings.bind(this);
    this.GetAllOrdersAdmin = this.GetAllOrdersAdmin.bind(this);
    this.GetOrderHistory = this.GetOrderHistory.bind(this);
    this.GetOrderTradeHistory = this.GetOrderTradeHistory.bind(this);
  }
  PlaceOrModifyOrders(request: PlaceOrModifyOrdersRequest): Promise<PlaceOrModifyOrdersResponse> {
    const data = PlaceOrModifyOrdersRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "PlaceOrModifyOrders", data);
    return promise.then((data) => PlaceOrModifyOrdersResponse.decode(_m0.Reader.create(data)));
  }

  CancelOrders(request: CancelOrdersRequest): Promise<CancelOrdersResponse> {
    const data = CancelOrdersRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "CancelOrders", data);
    return promise.then((data) => CancelOrdersResponse.decode(_m0.Reader.create(data)));
  }

  GetOrder(request: GetOrderRequest): Promise<Order> {
    const data = GetOrderRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetOrder", data);
    return promise.then((data) => Order.decode(_m0.Reader.create(data)));
  }

  GetAllOrders(request: GetAllOrdersRequest): Promise<Orders> {
    const data = GetAllOrdersRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetAllOrders", data);
    return promise.then((data) => Orders.decode(_m0.Reader.create(data)));
  }

  GetHoldings(request: GetHoldingsRequest): Promise<GetHoldingsResponse> {
    const data = GetHoldingsRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetHoldings", data);
    return promise.then((data) => GetHoldingsResponse.decode(_m0.Reader.create(data)));
  }

  GetAllOrdersAdmin(request: GetAllOrdersRequest): Promise<Orders> {
    const data = GetAllOrdersRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetAllOrdersAdmin", data);
    return promise.then((data) => Orders.decode(_m0.Reader.create(data)));
  }

  GetOrderHistory(request: GetOrderHistoryRequest): Promise<GetOrderHistoryResponse> {
    const data = GetOrderHistoryRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetOrderHistory", data);
    return promise.then((data) => GetOrderHistoryResponse.decode(_m0.Reader.create(data)));
  }

  GetOrderTradeHistory(request: GetOrderTradeHistoryRequest): Promise<GetOrderTradeHistoryResponse> {
    const data = GetOrderTradeHistoryRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetOrderTradeHistory", data);
    return promise.then((data) => GetOrderTradeHistoryResponse.decode(_m0.Reader.create(data)));
  }
}

interface Rpc {
  request(service: string, method: string, data: Uint8Array): Promise<Uint8Array>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
